
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3iK0z", function(module, exports) {

$parcel$export(module.exports, "LivePagesEllipsisDropdownComponent", () => $0cb53d4e029029d2$export$ad9980f718bbeeb6);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $inPa6 = parcelRequire("inPa6");

var $ahaN7 = parcelRequire("ahaN7");

var $5izcQ = parcelRequire("5izcQ");

var $bbp3G = parcelRequire("bbp3G");

var $gqqjz = parcelRequire("gqqjz");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $eSLr0 = parcelRequire("eSLr0");
var $6ld6a = parcelRequire("6ld6a");

var $hFGQl = parcelRequire("hFGQl");
var $jBnsv = parcelRequire("jBnsv");

var $cEgMD = parcelRequire("cEgMD");

var $2CO9C = parcelRequire("2CO9C");
var $gmAL5 = parcelRequire("gmAL5");

var $1PC5x = parcelRequire("1PC5x");

var $ljm2R = parcelRequire("ljm2R");

var $gDbO8 = parcelRequire("gDbO8");

var $dPJCf = parcelRequire("dPJCf");

var $2kB0r = parcelRequire("2kB0r");
var $4wEOc = parcelRequire("4wEOc");

var $efvKr = parcelRequire("efvKr");

var $kSPGK = parcelRequire("kSPGK");

var $5KL6w = parcelRequire("5KL6w");

var $5SlMo = parcelRequire("5SlMo");

var $5kTjf = parcelRequire("5kTjf");

var $iQb1R = parcelRequire("iQb1R");

var $6tSjb = parcelRequire("6tSjb");
var $0cb53d4e029029d2$var$GroupItemsKey = /*#__PURE__*/ function(GroupItemsKey) {
    GroupItemsKey["PUBLISH"] = "publish";
    GroupItemsKey["OWNERSHIP"] = "ownership";
    GroupItemsKey["PAGEACTIONS"] = "pageactions";
    GroupItemsKey["PAGEAPPS"] = "pageapps";
    GroupItemsKey["OTHER"] = "other";
    return GroupItemsKey;
}($0cb53d4e029029d2$var$GroupItemsKey || {});
var $0cb53d4e029029d2$var$SubMenuTypes = /*#__PURE__*/ function(SubMenuTypes) {
    SubMenuTypes["Export"] = "export";
    SubMenuTypes["Advanced"] = "advanced";
    SubMenuTypes["Attachments"] = "attachments";
    SubMenuTypes["Apps"] = "apps";
    SubMenuTypes["ContentOwnership"] = "content-ownership";
    return SubMenuTypes;
}($0cb53d4e029029d2$var$SubMenuTypes || {});
const $0cb53d4e029029d2$export$ad9980f718bbeeb6 = ({ contentId: contentId, spaceKey: spaceKey, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, allowedEllipsisButtons: allowedEllipsisButtons, onClickPublish: onClickPublish, saveDraft: saveDraft, isViewMode: isViewMode, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, isInitialMenuOpen: isInitialMenuOpen = false, isDisabled: isDisabled })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $gwFzn.useState)(isInitialMenuOpen);
    const [openSubMenu, setOpenSubMenu] = (0, $gwFzn.useState)(null);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    // We have to get optimisticTitle here instead of inside PublishItem because
    // useOptimisticTitleChange only gets title updates after this component has mounted.
    const { optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, null);
    const { isEnabled: isClassificationEnabled } = (0, $4wEOc.useIsDataClassificationEnabledForOrg)();
    const enterPresenterModeAndStartExperience = (0, $5kTjf.useEnterPresenterModeAndStartExperience)(contentId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { loading: webItemLoading, error: webItemError, webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        location: [
            (0, $eSLr0.TOOLS_MENU_CONTAINER),
            (0, $eSLr0.PAGE_BUTTONS)
        ],
        contentId: contentId
    });
    if (webItemLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6tSjb.EllipsisPlaceholder), null);
    const isWebItemAvailable = !webItemLoading && !webItemError;
    const isAllowed = (menuItem)=>allowedEllipsisButtons?.includes(menuItem) ?? true;
    const handleMenuOpenChange = ({ isOpen: isOpen })=>{
        setIsMenuOpen(isOpen);
        if (isMenuOpen) createAnalyticsEvent?.({
            type: 'sendScreenEvent',
            data: {
                name: 'livePagesEllipsisDropdownForMoreItems'
            }
        }).fire();
        else closeAllSubMenus();
    };
    const handleSubMenuMouseEnter = (submenuType)=>{
        setOpenSubMenu(submenuType);
    };
    const handleSubMenuItemClick = (submenuType)=>{
        if (openSubMenu === submenuType) setOpenSubMenu(null);
        else setOpenSubMenu(submenuType);
    };
    const closeAllSubMenus = ()=>{
        setOpenSubMenu(null);
    };
    const closeMenu = ()=>{
        setIsMenuOpen(false);
    };
    const makeLinkToThisPageDialogOpener = (dialogs)=>()=>{
            dialogs.showModal((0, $1PC5x.LinkToThisPageDialog), {
                contentId: contentId
            });
        };
    const navigateToAttachments = ()=>{
        const viewAttachmentsWebItem = webItems.find((webItem)=>webItem.id === 'view-attachments-link');
        if (viewAttachmentsWebItem?.url) push(viewAttachmentsWebItem?.url);
    };
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    const menuItemWrapper = (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            onMouseEnter: closeAllSubMenus
        }, children);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const getOwnershipGroupItems = (dialogs)=>[
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.ViewChangesItem), {
                    contentId: contentId,
                    dialogs: dialogs,
                    saveDraft: saveDraft
                }),
                allowed: !isViewMode && isAllowed((0, $iQb1R.Buttons).VIEW_CHANGES)
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.ChangePageOwnershipItem), {
                    webItems: webItems,
                    contentId: contentId,
                    closeMenu: closeMenu,
                    isOpen: openSubMenu === "content-ownership",
                    onClick: ()=>handleSubMenuItemClick("content-ownership"),
                    onMouseEnter: ()=>handleSubMenuMouseEnter("content-ownership"),
                    closePopup: ()=>setOpenSubMenu(null)
                }),
                isSubMenu: true,
                allowed: !isViewMode
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2kB0r.EllipsisClassificationMenuItem), null),
                allowed: !isViewMode && isClassificationEnabled && !isCompanyHub
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.EditLabelItem), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    dialogs: dialogs
                }),
                allowed: !isViewMode && isAllowed((0, $iQb1R.Buttons).EDIT_LABELS) && !isCompanyHub
            }
        ];
    const getPageActionGroupItems = (dialogs)=>[
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.CopyPageItem), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    dialogs: dialogs
                }),
                allowed: !isViewMode
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.MovePageItem), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
                }),
                allowed: !isViewMode && isAllowed((0, $iQb1R.Buttons).MOVE_PAGE) && !isCompanyHub
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.ExportMenuItem), {
                    isSubMenuOpen: openSubMenu === "export",
                    handleMouseEnter: ()=>handleSubMenuMouseEnter("export"),
                    handleClick: ()=>handleSubMenuItemClick("export"),
                    webItems: webItems,
                    onOpenChange: ()=>setOpenSubMenu(null)
                }),
                isSubMenu: true,
                allowed: isAllowed((0, $iQb1R.Buttons).EXPORT) && isWebItemAvailable
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.ArchiveLinkMenuItem), {
                    contentId: contentId,
                    webItems: webItems,
                    dialogs: dialogs
                }),
                allowed: !isViewMode && isAllowed((0, $iQb1R.Buttons).ARCHIVE) && isWebItemAvailable
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.DeletePageItem), {
                    contentId: contentId,
                    webItems: webItems,
                    dialogs: dialogs
                }),
                allowed: !isViewMode && isWebItemAvailable
            }
        ];
    const getPageAppsGroupItems = (forgeMenuItems)=>{
        const pageAppItems = webItems.filter((item)=>item?.completeKey?.includes((0, $jBnsv.CONNECT_APP_PREFIX_KEY)) && item?.id !== (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID));
        return [
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.PageAppsMenuItem), {
                    isSubMenuOpen: openSubMenu === "apps",
                    handleMouseEnter: ()=>handleSubMenuMouseEnter("apps"),
                    handleClick: ()=>handleSubMenuItemClick("apps"),
                    webItems: pageAppItems,
                    forgeMenuItems: forgeMenuItems,
                    onOpenChange: ()=>setOpenSubMenu(null)
                }),
                isSubMenu: true,
                allowed: pageAppItems.length > 0 || forgeMenuItems.length > 0
            }
        ];
    };
    const getPublishGroupItems = (flags)=>[
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.PublishItem), {
                    contentId: contentId,
                    saveDraft: saveDraft,
                    onClickPublish: onClickPublish,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    optimisticTitle: optimisticTitle
                }),
                allowed: !isViewMode
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.TemplateMenuItem), {
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel
                }),
                allowed: !isViewMode
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.PresenterModeItem), {
                    webItems: webItems,
                    contentId: contentId
                }),
                allowed: true
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gDbO8.LivePagesModeChanger), {
                    contentId: contentId,
                    flags: flags,
                    analyticsSource: "livePagesEllipsisDropdown"
                }),
                allowed: (0, $9wGTI.fg)('cc_live_pages_toggle_move')
            }
        ];
    const getOtherGroupItems = (dialogs)=>[
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.ResolvedCommentsItem), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    dialogs: dialogs
                }),
                allowed: isAllowed((0, $iQb1R.Buttons).RESOLVED_COMMENTS)
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.AnalyticsItem), {
                    webItems: webItems
                }),
                allowed: !isViewMode && isWebItemAvailable
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.PageHistoryMenuItem), {
                    webItems: webItems
                }),
                allowed: true
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.AdvancedDetailsMenuItem), {
                    isSubMenuOpen: openSubMenu === "advanced",
                    handleMouseEnter: ()=>handleSubMenuMouseEnter("advanced"),
                    handleClick: ()=>handleSubMenuItemClick("advanced"),
                    webItems: webItems,
                    onOpenChange: ()=>setOpenSubMenu(null)
                }),
                isSubMenu: true,
                allowed: isAllowed((0, $iQb1R.Buttons).ADVANCED) && isWebItemAvailable
            },
            {
                component: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kTjf.AttachmentsMenuItem), {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    webItems: webItems,
                    isSubMenuOpen: openSubMenu === "attachments",
                    onOpenChange: ()=>setOpenSubMenu(null),
                    handleMouseEnter: ()=>handleSubMenuMouseEnter("attachments"),
                    handleClick: ()=>handleSubMenuItemClick("attachments")
                }),
                isSubMenu: true,
                allowed: isAllowed((0, $iQb1R.Buttons).ATTACHMENTS) && isWebItemAvailable
            }
        ];
    const getItems = (dialogs, forgeMenuItems, flags)=>{
        const groupItems = {
            ["publish"]: getPublishGroupItems(flags),
            ["ownership"]: getOwnershipGroupItems(dialogs),
            ["pageactions"]: getPageActionGroupItems(dialogs),
            ["pageapps"]: getPageAppsGroupItems(forgeMenuItems),
            ["other"]: getOtherGroupItems(dialogs)
        };
        return Object.entries(groupItems).reduce((acc, [key, items], index, arr)=>{
            const components = items.filter((item)=>item.allowed).map((item)=>item.isSubMenu ? item.component : menuItemWrapper(item.component));
            if (components.length > 0) acc.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ahaN7.default), {
                key: key,
                testId: `group-${key}`,
                hasSeparator: index > 0 && index <= arr.length - 1
            }, components));
            return acc;
        }, []);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).PAGE_MODES
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bbp3G.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (dialogs, flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2CO9C.ForgeContentTools), {
            spaceKey: spaceKey,
            contentId: contentId,
            onLoadComplete: ()=>setIsMenuOpen(false),
            isDropdownMenuOpen: isMenuOpen,
            dialogs: dialogs,
            lazyLoaderPlaceholderComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gmAL5.ForgeContentToolsPlaceholder), null)
        }, (forgeMenuItems)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "live-pages-changeboarding.publish-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5SlMo.CommonDropdownMenu), {
                isMenuOpen: isMenuOpen,
                handleMenuOpenChange: handleMenuOpenChange,
                isDisabled: isDisabled
            }, getItems(dialogs, forgeMenuItems, flags)), !isLiveEditMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
                accelerator: (0, $ljm2R.LINK_TO_THIS_PAGE_SHORTCUT),
                listener: makeLinkToThisPageDialogOpener(dialogs)
            }), !isLiveEditMode && isAllowed((0, $iQb1R.Buttons).ATTACHMENTS) && isWebItemAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
                deprecatedAccelerator: (0, $ljm2R.VIEW_ATTACHMENTS_SHORTCUT),
                accelerator: (0, $ljm2R.UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT),
                listener: navigateToAttachments
            }), isLiveEditMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
                accelerator: (0, $ljm2R.EDITOR2_SHORTCUTS).PUBLISH,
                listener: onClickPublish({})
            }), isAllowed((0, $iQb1R.Buttons).PRESENT) && isWebItemAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
                key: "presenter-mode-from-live-docs-menu-item-keyboard-shortcut"
            }, (enterPresenterMode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
                    deprecatedAccelerator: !isLiveEditMode ? (0, $ljm2R.PRESENTATION_MODE_SHORTCUT) : undefined,
                    accelerator: (0, $ljm2R.isSafari)() ? (0, $ljm2R.UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI) : (0, $ljm2R.UNIVERSAL_PRESENTATION_MODE_SHORTCUT),
                    listener: enterPresenterModeAndStartExperience({
                        enterPresenterMode: enterPresenterMode,
                        isTriggedByKeyboardShortcut: true
                    })
                }))))));
};

});
parcelRegister("6ld6a", function(module, exports) {

$parcel$export(module.exports, "useWebItemLocation", () => $f64809aa9d8f3ca2$export$13a30d244c53e90d);

var $diswb = parcelRequire("diswb");

var $jV49M = parcelRequire("jV49M");

var $jIQq0 = parcelRequire("jIQq0");

var $fjiOd = parcelRequire("fjiOd");

var $62BfR = parcelRequire("62BfR");
const $f64809aa9d8f3ca2$export$13a30d244c53e90d = ({ location: location, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, fetchPolicy: fetchPolicy = 'cache-and-network', allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $fjiOd.WebItemLocationQuery), {
        fetchPolicy: fetchPolicy,
        variables: {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        skip: skipQuery
    });
    if (!data) return {
        loading: loading,
        error: error,
        webItems: [],
        webSections: []
    };
    // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
    // with the atlToken in all section items
    const webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections, {
        allowedWebItems: allowedWebItems,
        notAllowedWebItems: notAllowedWebItems
    });
    const webSections = (0, (/*@__PURE__*/$parcel$interopDefault($jIQq0)))(webItems.map((webItem)=>webItem.section));
    webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
    return {
        // Since the default fetchPolicy is cache-and-network
        // loading field will be true, false, true (background refetch), false
        // Query is refreshing when data not empty but loading is true
        // Padding loading false to avoid reverting back to the empty state or loading skeleton.
        // This aligns with confluence/next/packages/web-item-location/src/WebItemLocation.tsx
        loading: false,
        error: error,
        webItems: webItems,
        webSections: webSections
    };
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($jV49M)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (item === null || item.completeKey === null) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};

});
parcelRegister("62BfR", function(module, exports) {

$parcel$export(module.exports, "replaceAtlTokenPlaceholder", () => $d97d2e8640b15cc8$export$87286345b169ae5e);
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}

});


parcelRegister("hFGQl", function(module, exports) {

$parcel$export(module.exports, "CONTENT_METADATA_JIRA_ID", () => $d3e8bd0515c02c91$export$8b02acc4219d8357);
$parcel$export(module.exports, "CONTENT_METADATA_ATTACHMENTS_ID", () => $d3e8bd0515c02c91$export$a93781d2f10a1a54);
$parcel$export(module.exports, "CONTENT_METADATA_PAGE_RESTRICTIONS_ID", () => $d3e8bd0515c02c91$export$126027a563ee39b2);
$parcel$export(module.exports, "DRAFT_STATUS_LOZENGE_ID", () => $d3e8bd0515c02c91$export$e5b04880f6b7bed);
$parcel$export(module.exports, "SCHEDULED_STATUS_LOZENGE_ID", () => $d3e8bd0515c02c91$export$b6c67256b8045624);
$parcel$export(module.exports, "EDIT_PAGE_METADATA_RESTRICTIONS_ID", () => $d3e8bd0515c02c91$export$1b048ac0db68f7ab);
$parcel$export(module.exports, "INVITE_TO_EDIT_ID", () => $d3e8bd0515c02c91$export$607df6eced5a588c);
$parcel$export(module.exports, "ANALYTICS_ADDON_BYLINE_ID", () => $d3e8bd0515c02c91$export$c8362b8678d6b894);
$parcel$export(module.exports, "ANALYTICS_ADDON_ACTIONS_MENU_ID", () => $d3e8bd0515c02c91$export$de7935ab18e02484);
$parcel$export(module.exports, "ANALYTICS_MODERATE_ADDON_ACTIONS_MENU_ID", () => $d3e8bd0515c02c91$export$a643e9449b465583);
const $d3e8bd0515c02c91$export$8b02acc4219d8357 = 'content-metadata-jira';
const $d3e8bd0515c02c91$export$a93781d2f10a1a54 = 'content-metadata-attachments';
const $d3e8bd0515c02c91$export$126027a563ee39b2 = 'content-metadata-page-restrictions';
const $d3e8bd0515c02c91$export$e5b04880f6b7bed = 'draft-status-lozenge';
const $d3e8bd0515c02c91$export$b6c67256b8045624 = 'status-lozenge-scheduled';
const $d3e8bd0515c02c91$export$1b048ac0db68f7ab = 'rte-button-restrictions';
const $d3e8bd0515c02c91$export$607df6eced5a588c = 'inviteToEdit';
const $d3e8bd0515c02c91$export$c8362b8678d6b894 = 'com.addonengine.analytics__analytics-content-byline-item';
const $d3e8bd0515c02c91$export$de7935ab18e02484 = 'com.addonengine.analytics__analytics-content-menu-item';
const $d3e8bd0515c02c91$export$a643e9449b465583 = 'com.addonengine.analytics.moderate__analytics-content-menu-item';

});

parcelRegister("2CO9C", function(module, exports) {

$parcel$export(module.exports, "ContentTools", () => $06006296d2229df2$export$8e3d4e3d40a48fc4);
$parcel$export(module.exports, "ForgeContentTools", () => $06006296d2229df2$export$7cf22b806dbb23cb);
$parcel$export(module.exports, "LazyForgeContentTools", () => $06006296d2229df2$export$fcc1c0135b5761c6);
$parcel$export(module.exports, "ForgeContentToolsPlaceholder", () => (parcelRequire("gmAL5")).ForgeContentToolsPlaceholder);

var $jmjWc = parcelRequire("jmjWc");

var $gmAL5 = parcelRequire("gmAL5");

const $06006296d2229df2$export$8e3d4e3d40a48fc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-9At8",
    name: "ContentTools",
    loader: async ()=>(await (parcelRequire("kYf3l"))).ContentTools
});

const $06006296d2229df2$export$7cf22b806dbb23cb = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZdHYO",
    name: "ForgeContentTools",
    loader: async ()=>(await (parcelRequire("aa4gF"))).ForgeContentTools,
    loading: (0, $gmAL5.ForgeContentToolsPlaceholder)
});

const $06006296d2229df2$export$fcc1c0135b5761c6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FBA4l",
    name: "LazyForgeContentTools",
    loader: async ()=>(await (parcelRequire("aa4gF"))).ForgeContentTools
});

});
parcelRegister("gmAL5", function(module, exports) {

$parcel$export(module.exports, "ForgeContentToolsPlaceholder", () => $27398e8eb4d75565$export$e47963ce1de88cbf);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4KS7f = parcelRequire("4KS7f");

var $9VJDA = parcelRequire("9VJDA");
const $27398e8eb4d75565$var$i18n = (0, $2nPZH.defineMessages)({
    more: {
        id: "content-tools.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $27398e8eb4d75565$export$e47963ce1de88cbf = ()=>{
    const intl = (0, $dBxQj.default)();
    const label = intl.formatMessage($27398e8eb4d75565$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: label,
        color: "var(--ds-icon, #44546F)",
        spacing: "spacious"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};

});

parcelRegister("kYf3l", function(module, exports) {

let $f4451675dfd237a5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f4451675dfd237a5$var$load("dC3sP"),
    $f4451675dfd237a5$var$load("3xec3"),
    $f4451675dfd237a5$var$load("jHDh2"),
    $f4451675dfd237a5$var$load("jrkFV"),
    $f4451675dfd237a5$var$load("gZKQW"),
    $f4451675dfd237a5$var$load("dPdkf"),
    $f4451675dfd237a5$var$load("63hQz"),
    $f4451675dfd237a5$var$load("3zuUe"),
    $f4451675dfd237a5$var$load("6Zezm"),
    $f4451675dfd237a5$var$load("732y6"),
    $f4451675dfd237a5$var$load("j2I3I"),
    $f4451675dfd237a5$var$load("e6bZt"),
    $f4451675dfd237a5$var$load("7rEYM"),
    $f4451675dfd237a5$var$load("3TNOq"),
    $f4451675dfd237a5$var$load("eCgOQ"),
    $f4451675dfd237a5$var$load("ipTFT"),
    $f4451675dfd237a5$var$load("6qah4"),
    $f4451675dfd237a5$var$load("ekztv"),
    $f4451675dfd237a5$var$load("dTsOE"),
    $f4451675dfd237a5$var$load("bzc8Q"),
    $f4451675dfd237a5$var$load("kyfJT"),
    $f4451675dfd237a5$var$load("hWs86")
]).then(()=>parcelRequire('bTUBB'));

});

parcelRegister("aa4gF", function(module, exports) {

let $765e26087d1e47e8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $765e26087d1e47e8$var$load("bzc8Q"),
    $765e26087d1e47e8$var$load("kyfJT")
]).then(()=>parcelRequire('dhbEh'));

});


parcelRegister("1PC5x", function(module, exports) {

$parcel$export(module.exports, "LinkToThisPageDialog", () => $297029061926b2dd$export$77691412571457f);

var $jmjWc = parcelRequire("jmjWc");

const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("1Xhtn"))).LinkToThisPageDialog
});

});
parcelRegister("1Xhtn", function(module, exports) {

let $16c8dae07c4a2efd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $16c8dae07c4a2efd$var$load("dXoLf").then(()=>parcelRequire('gaLJH'));

});


parcelRegister("gDbO8", function(module, exports) {

$parcel$export(module.exports, "LivePagesModeChanger", () => $074be0d28909724e$export$9674de41b3e1d3c1);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $ljm2R = parcelRequire("ljm2R");

var $7W8i8 = parcelRequire("7W8i8");

var $9wGTI = parcelRequire("9wGTI");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $efvKr = parcelRequire("efvKr");

var $jhwJP = parcelRequire("jhwJP");

var $7K2Hq = parcelRequire("7K2Hq");

var $khqIr = parcelRequire("khqIr");
const $074be0d28909724e$var$i18nBase = (0, $2nPZH.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title",
        defaultMessage: "You\u2019re editing this page"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title",
        defaultMessage: "You\u2019re viewing this page"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $074be0d28909724e$var$i18nLiveDocs = (0, $2nPZH.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    }
});
const $074be0d28909724e$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($074be0d28909724e$var$i18nBase, $074be0d28909724e$var$i18nLiveDocs);
const $074be0d28909724e$export$9674de41b3e1d3c1 = ({ contentId: contentId, isDisabled: isDisabled, flags: flags, analyticsSource: analyticsSource, elemAfter: elemAfter })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const [{ mode: livePageMode }, { setMode: setLivePageMode }] = (0, $efvKr.useLivePageMode)();
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $e9zUf.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $e9zUf.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const handleModeChange = (newMode)=>{
        const modeDetails = {
            view: {
                title: intl.formatMessage($074be0d28909724e$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
                description: intl.formatMessage($074be0d28909724e$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                    keyCombination: (0, $ljm2R.getShortcutString)((0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_EDIT))
                })
            },
            edit: {
                title: intl.formatMessage($074be0d28909724e$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
                description: intl.formatMessage($074be0d28909724e$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                    keyCombination: (0, $ljm2R.getShortcutString)((0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_VIEW))
                })
            }
        };
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            const { title: title, description: description } = selectedModeDetails;
            setLivePageMode(newMode);
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                source: analyticsSource,
                action: 'changed',
                actionSubject: 'mode',
                actionSubjectId: 'livePagesModeSwitcher',
                attributes: {
                    previousMode: livePageMode,
                    newMode: newMode
                },
                objectType: 'page',
                objectId: contentId
            }
        })?.fire();
    };
    const LivePagesModeChangerComponent = (0, $9wGTI.fg)('cc_live_pages_toggle_move') ? (0, $khqIr.LivePagesModeChangerDropdown) : (0, $7K2Hq.LivePagesModeToggle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(LivePagesModeChangerComponent, {
        selectedMode: livePageMode ?? 'view',
        onChange: handleModeChange,
        isDisabled: isDisabled,
        elemAfter: elemAfter
    });
};

});
parcelRegister("7K2Hq", function(module, exports) {

$parcel$export(module.exports, "LivePagesModeToggle", () => $661af7b5f3d7fe7a$export$988dc34972eeea1d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $3gadb = parcelRequire("3gadb");

var $82gXq = parcelRequire("82gXq");

var $dcJ7R = parcelRequire("dcJ7R");
var $2W0qg = parcelRequire("2W0qg");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $ljm2R = parcelRequire("ljm2R");
const $661af7b5f3d7fe7a$var$i18n = (0, $2nPZH.defineMessages)({
    editingText: {
        id: "live-pages-features.live-pages-mode-switcher.editing.label",
        defaultMessage: "Editing"
    },
    modeSwitcherLabel: {
        id: "live-pages-features.live-pages-mode-switcher.label",
        defaultMessage: "Page mode"
    },
    modeToggleToEditTooltip: {
        id: "live-pages-features.live-pages-mode-switcher.editing.edit-tooltip",
        defaultMessage: "Edit"
    },
    modeToggleToViewTooltip: {
        id: "live-pages-features.live-pages-mode-switcher.editing.view-tooltip",
        defaultMessage: "Switch to viewing"
    }
});
const $661af7b5f3d7fe7a$var$toggleWrapperXcss = (0, $ecnYn.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    userSelect: 'none',
    marginTop: 'space.025'
});
const $661af7b5f3d7fe7a$var$pressableDisabledXcss = (0, $ecnYn.xcss)({
    cursor: 'not-allowed'
});
const $661af7b5f3d7fe7a$export$988dc34972eeea1d = ({ selectedMode: selectedMode, onChange: onChange, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const toggleRef = (0, $gwFzn.useRef)();
    const updateTooltipRef = (0, $gwFzn.useRef)();
    const tooltipMessage = selectedMode === 'edit' ? $661af7b5f3d7fe7a$var$i18n.modeToggleToViewTooltip : $661af7b5f3d7fe7a$var$i18n.modeToggleToEditTooltip;
    const keyCombination = selectedMode === 'edit' ? (0, $ljm2R.getShortcutString)((0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_VIEW)) : (0, $ljm2R.getShortcutString)((0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_EDIT));
    (0, $gwFzn.useLayoutEffect)(()=>{
        updateTooltipRef?.current?.();
    }, [
        tooltipMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: isDisabled ? '' : ({ update: update })=>{
            // Ensures tooltip position updates when user changes modes and text gets updated
            // Per documentation: https://atlassian.design/components/tooltip/examples#updating-tooltip-position
            updateTooltipRef.current = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
                shortcut: keyCombination,
                contentBefore: formatMessage(tooltipMessage),
                isEditorShortcut: true
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
        xcss: $661af7b5f3d7fe7a$var$toggleWrapperXcss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
        testId: "live-page-mode-toggle-label",
        onClick: ()=>{
            if (isDisabled) return;
            toggleRef?.current?.focus(); // Maintain a11y+design consistency by focusing on the toggle when the label is clicked
            onChange?.(selectedMode === 'edit' ? 'view' : 'edit');
        },
        backgroundColor: "color.background.neutral.subtle",
        "aria-label": formatMessage($661af7b5f3d7fe7a$var$i18n.modeSwitcherLabel),
        xcss: isDisabled ? $661af7b5f3d7fe7a$var$pressableDisabledXcss : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        weight: "medium",
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $661af7b5f3d7fe7a$var$i18n.editingText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $82gXq.default), {
        ref: toggleRef,
        onChange: (e)=>{
            onChange?.(e?.target?.checked ? 'edit' : 'view');
        },
        label: formatMessage($661af7b5f3d7fe7a$var$i18n.modeSwitcherLabel),
        isChecked: selectedMode === 'edit',
        isDisabled: isDisabled,
        testId: "live-page-mode-toggle"
    })));
};

});

parcelRegister("khqIr", function(module, exports) {

$parcel$export(module.exports, "LivePagesModeChangerDropdown", () => $d0922dfcb7434c92$export$7266636f729f5bc9);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $5dK2X = parcelRequire("5dK2X");

var $dAYOx = parcelRequire("dAYOx");

var $x4n5k = parcelRequire("x4n5k");

var $1Zr9M = parcelRequire("1Zr9M");

var $ljm2R = parcelRequire("ljm2R");
const $d0922dfcb7434c92$var$i18n = (0, $2nPZH.defineMessages)({
    modeToggleToEdit: {
        id: "live-pages-features.live-pages-mode-switcher.editing.edit-dropdown",
        defaultMessage: "Resume editing"
    },
    modeToggleToView: {
        id: "live-pages-features.live-pages-mode-switcher.editing.view-dropdown",
        defaultMessage: "Switch to viewing"
    }
});
const $d0922dfcb7434c92$export$7266636f729f5bc9 = ({ selectedMode: selectedMode, onChange: onChange, isDisabled: isDisabled, elemAfter: elemAfter })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const dropdownMenuContent = selectedMode === 'edit' ? $d0922dfcb7434c92$var$i18n.modeToggleToView : $d0922dfcb7434c92$var$i18n.modeToggleToEdit;
    const shortcut = selectedMode === 'edit' ? (0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_VIEW) : (0, $ljm2R.LIVE_PAGE_MODE_SWITCH_TO_EDIT);
    const keyCombination = (0, $ljm2R.getShortcutString)(shortcut);
    const getShortcutComponent = ()=>{
        if (!keyCombination) return null;
        if (elemAfter) return elemAfter({
            shortcutKeys: keyCombination.split(' '),
            id: 'viewEditToggle'
        });
        // for the old ..., menu we just have the plain shortcut string since the preview menu item is also doing this
        return keyCombination;
    };
    const Icon = selectedMode === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($x4n5k))) : (0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Icon, {
            label: ""
        }),
        elemAfter: getShortcutComponent(),
        testId: "live-page-mode-toggle-label",
        onClick: ()=>onChange?.(selectedMode === 'view' ? 'edit' : 'view'),
        "aria-label": formatMessage(dropdownMenuContent),
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        color: isDisabled ? 'color.text.disabled' : 'color.text'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), dropdownMenuContent)));
};

});
parcelRegister("x4n5k", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de790aa34d87b38953e022081bae4952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0636793d229b2435$var$_react = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $0636793d229b2435$var$_baseNew = $0636793d229b2435$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $0636793d229b2435$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0636793d229b2435$var$BookOpenIcon = (props)=>/*#__PURE__*/ $0636793d229b2435$var$_react.default.createElement($0636793d229b2435$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$0636793d229b2435$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $0636793d229b2435$var$_default = module.exports.default = $0636793d229b2435$var$BookOpenIcon;

});



parcelRegister("2kB0r", function(module, exports) {

$parcel$export(module.exports, "EllipsisClassificationMenuItem", () => $6e3699f987da9ca3$export$805becd8a04238d2);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $dAYOx = parcelRequire("dAYOx");

var $40pD8 = parcelRequire("40pD8");
const $6e3699f987da9ca3$var$messages = (0, $2nPZH.defineMessages)({
    classifyContent: {
        id: "data-classification.ellipsis-classification-menu-item.classify-content",
        defaultMessage: "Classify content"
    }
});
const $6e3699f987da9ca3$export$805becd8a04238d2 = ({ elemBefore: elemBefore })=>{
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const onClick = ()=>{
        setIsClassificationModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "classify-content",
        onClick: onClick,
        elemBefore: elemBefore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $6e3699f987da9ca3$var$messages.classifyContent));
};

});

parcelRegister("5SlMo", function(module, exports) {

$parcel$export(module.exports, "CommonDropdownMenu", () => $79e94f3a61d46da4$export$6885a1ceb54a0bf4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $1qfLF = parcelRequire("1qfLF");

var $52EPl = parcelRequire("52EPl");

var $9VJDA = parcelRequire("9VJDA");

var $3gadb = parcelRequire("3gadb");
const $79e94f3a61d46da4$var$i18n = (0, $2nPZH.defineMessages)({
    moreActions: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more.actions.tooltip",
        defaultMessage: "More actions"
    }
});
const $79e94f3a61d46da4$export$6885a1ceb54a0bf4 = ({ isMenuOpen: isMenuOpen, handleMenuOpenChange: handleMenuOpenChange, children: children, testId: testId = 'ellipsis-dropdown-menu', isDisabled: isDisabled, tooltipDisabledState: tooltipDisabledState })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const disabledTooltipI18nObject = {
        id: tooltipDisabledState
    };
    const disabledTooltipText = tooltipDisabledState ? formatMessage(disabledTooltipI18nObject) : '';
    const tooltip = isDisabled ? disabledTooltipText : formatMessage($79e94f3a61d46da4$var$i18n.moreActions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: isMenuOpen ? '' : tooltip,
        position: "bottom",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "ellipsis-dropdown-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "bottom-end",
        testId: testId,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1qfLF.default), {
                ...props,
                label: formatMessage($79e94f3a61d46da4$var$i18n.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                isDisabled: isDisabled,
                appearance: "subtle"
            }),
        appearance: "tall",
        isOpen: isMenuOpen,
        onOpenChange: handleMenuOpenChange
    }, children)));
};

});

parcelRegister("5kTjf", function(module, exports) {

$parcel$export(module.exports, "PublishItem", () => $604fac8d946e92cb$export$5d2b8308ae22bac0);
$parcel$export(module.exports, "ViewChangesItem", () => $604fac8d946e92cb$export$f28b24dc0422311f);
$parcel$export(module.exports, "EditLabelItem", () => $604fac8d946e92cb$export$9f7a934e6dd9791d);
$parcel$export(module.exports, "ResolvedCommentsItem", () => $604fac8d946e92cb$export$6ef7ff6844fac622);
$parcel$export(module.exports, "MovePageItem", () => $604fac8d946e92cb$export$52c3ed180557ae52);
$parcel$export(module.exports, "CopyPageItem", () => $604fac8d946e92cb$export$752310dc6b894807);
$parcel$export(module.exports, "ExportMenuItem", () => $604fac8d946e92cb$export$b945ccaa4d42d330);
$parcel$export(module.exports, "PageHistoryMenuItem", () => $604fac8d946e92cb$export$b0891f8ed710dfea);
$parcel$export(module.exports, "AttachmentsMenuItem", () => $604fac8d946e92cb$export$974c86dc01d0ca75);
$parcel$export(module.exports, "DeletePageItem", () => $604fac8d946e92cb$export$59a3c28f917ceccb);
$parcel$export(module.exports, "AnalyticsItem", () => $604fac8d946e92cb$export$d3300574d10089ff);
$parcel$export(module.exports, "ChangePageOwnershipItem", () => $604fac8d946e92cb$export$79990175e7fcba3a);
$parcel$export(module.exports, "AdvancedDetailsMenuItem", () => $604fac8d946e92cb$export$b037fbb835bc6c32);
$parcel$export(module.exports, "ArchiveLinkMenuItem", () => $604fac8d946e92cb$export$580a6a510077d1e2);
$parcel$export(module.exports, "TemplateMenuItem", () => $604fac8d946e92cb$export$ad35a31d7a6df26d);
$parcel$export(module.exports, "PageAppsMenuItem", () => $604fac8d946e92cb$export$7719ee501ebfc920);
$parcel$export(module.exports, "useEnterPresenterModeAndStartExperience", () => $604fac8d946e92cb$export$8bc386a38f677f82);
$parcel$export(module.exports, "PresenterModeItem", () => $604fac8d946e92cb$export$6cbf3f551981c306);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dAYOx = parcelRequire("dAYOx");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");

var $3gadb = parcelRequire("3gadb");

var $3KUzn = parcelRequire("3KUzn");

var $inPa6 = parcelRequire("inPa6");

var $8WXru = parcelRequire("8WXru");
var $5gFHQ = parcelRequire("5gFHQ");
var $6UxbI = parcelRequire("6UxbI");

var $kDxvw = parcelRequire("kDxvw");

var $jmjWc = parcelRequire("jmjWc");

var $3Syas = parcelRequire("3Syas");

var $5FwhF = parcelRequire("5FwhF");

var $v1jQ6 = parcelRequire("v1jQ6");

var $k0pnk = parcelRequire("k0pnk");

var $dZ4NH = parcelRequire("dZ4NH");

var $ge2sX = parcelRequire("ge2sX");

var $iff8m = parcelRequire("iff8m");

var $euL71 = parcelRequire("euL71");

var $2E1L5 = parcelRequire("2E1L5");
var $jcM8h = parcelRequire("jcM8h");

var $l3C2L = parcelRequire("l3C2L");

var $5fMeR = parcelRequire("5fMeR");

var $3mVfX = parcelRequire("3mVfX");

var $dIouf = parcelRequire("dIouf");

var $hFGQl = parcelRequire("hFGQl");

var $1NBp8 = parcelRequire("1NBp8");

var $kz1fW = parcelRequire("kz1fW");

var $9wGTI = parcelRequire("9wGTI");

var $7aRa9 = parcelRequire("7aRa9");

var $ljm2R = parcelRequire("ljm2R");

var $jhwJP = parcelRequire("jhwJP");

var $5KL6w = parcelRequire("5KL6w");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $5yVAS = parcelRequire("5yVAS");

var $7J5Uc = parcelRequire("7J5Uc");

var $7QM6o = parcelRequire("7QM6o");

var $93ydA = parcelRequire("93ydA");

var $lI54U = parcelRequire("lI54U");

var $6DX3n = parcelRequire("6DX3n");
const $604fac8d946e92cb$export$44655c98bbde4290 = (0, $2nPZH.defineMessages)({
    viewChangesTitle: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.view.changes.title",
        defaultMessage: "Latest changes"
    },
    copy: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.copy",
        defaultMessage: "Copy"
    },
    export: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.export",
        defaultMessage: "Export"
    },
    advanced: {
        defaultMessage: "Advanced details",
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.advanced"
    },
    publish: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish",
        defaultMessage: "Publish"
    },
    publishDots: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish-dots",
        defaultMessage: "Publish..."
    },
    archive: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.archive",
        defaultMessage: "Archive"
    },
    attachments: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.attachments",
        defaultMessage: "Attachments"
    },
    files: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.files",
        defaultMessage: "Files"
    },
    customContents: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.custom.contents",
        defaultMessage: "Custom Contents"
    },
    pageApps: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.page.apps",
        defaultMessage: "Apps"
    },
    presenterMode: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.presenter-mode",
        defaultMessage: "Present"
    }
});
const $604fac8d946e92cb$export$ec8a3a5a40656745 = (0, $2nPZH.defineMessages)({
    publish: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish.live-docs",
        defaultMessage: "Convert to page"
    },
    publishDots: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.publish-dots.live-docs",
        defaultMessage: "Convert to page..."
    }
});
const $604fac8d946e92cb$export$ba79d07cc96b64e3 = (0, $jhwJP.mergeLiveDocI18n)($604fac8d946e92cb$export$44655c98bbde4290, $604fac8d946e92cb$export$ec8a3a5a40656745);
const $604fac8d946e92cb$var$menuItemContainerStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'space.200'
});
const $604fac8d946e92cb$var$resolvedCommentCountStyles = (0, $ecnYn.xcss)({
    // min width is needed here to prevent layout shift when the count is loaded
    minWidth: '20px'
});
const $604fac8d946e92cb$var$analyticsSource = 'LivePagesEllipsisDropdownComponent';
const $604fac8d946e92cb$var$numbersRegex = /\d+/g;

const $604fac8d946e92cb$var$PublishButtonSpotlightLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UdJn_",
    name: "PublishButtonSpotlightLoader",
    loader: async ()=>(await (parcelRequire("kvwCJ"))).LivePagesPublishSpotlight
});
const $604fac8d946e92cb$export$5d2b8308ae22bac0 = (0, $7aRa9.withFlags)(({ contentId: contentId, saveDraft: saveDraft, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, optimisticTitle: optimisticTitle, flags: flags })=>{
    const { openPublishModal: openPublishModal } = (0, $kz1fW.usePublishModalMountActions)();
    const validatePageAndOpenModal = (0, $kz1fW.usePrePublishTitleValidation)({
        contentId: contentId,
        contentType: 'page',
        isUnpublishedDraft: false,
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        onBeforeValidation: (0, $gwFzn.useCallback)(()=>{
            saveDraft?.();
        }, [
            saveDraft
        ]),
        onValidationSuccess: openPublishModal,
        analyticsSource: 'LivePagesEllipsis',
        optimisticTitle: optimisticTitle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "live-pages-onboarding.publish-button-in-overflow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: (0, $ljm2R.getShortcutString)((0, $ljm2R.EDITOR2_SHORTCUTS).PUBLISH)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "ellipsis-publish-button",
        onClick: validatePageAndOpenModal('LivePagesEllipsisPublishItem')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.publishDots)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($604fac8d946e92cb$var$PublishButtonSpotlightLoader, null));
});
const $604fac8d946e92cb$export$f28b24dc0422311f = ({ contentId: contentId, dialogs: dialogs, saveDraft: saveDraft })=>{
    const intl = (0, $dBxQj.default)();
    const onClick = (0, $gwFzn.useCallback)(()=>{
        saveDraft?.();
        dialogs.showModal((0, $l3C2L.ViewChangesDialogLoader), {
            contentId: contentId,
            title: intl.formatMessage($604fac8d946e92cb$export$ba79d07cc96b64e3.viewChangesTitle)
        });
    }, [
        contentId,
        dialogs,
        intl,
        saveDraft
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "view-changes",
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).viewChanges));
};
const $604fac8d946e92cb$export$9f7a934e6dd9791d = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $k0pnk.EditLabelDropdownItem), {
        contentId: contentId || '',
        spaceKey: spaceKey,
        dialogs: dialogs
    });
const $604fac8d946e92cb$export$6ef7ff6844fac622 = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>{
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "resolved-comments",
        onClick: ()=>{
            if ((0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                return;
            }
            dialogs.showModal((0, $dZ4NH.ResolvedInlineCommentsDialogLoader), {
                spaceKey: spaceKey,
                contentId: contentId,
                context: 'editor'
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $604fac8d946e92cb$var$menuItemContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).resolvedComments), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $604fac8d946e92cb$var$resolvedCommentCountStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dZ4NH.ResolvedInlineCommentsCounterLoader), {
        contentId: contentId
    }))));
};
const $604fac8d946e92cb$export$52c3ed180557ae52 = ({ contentId: contentId, spaceKey: spaceKey, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $v1jQ6.EditorMovePageButtonLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        appearance: "dropdownItem",
        analyticsSource: $604fac8d946e92cb$var$analyticsSource,
        key: "move-page-button",
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        isUnpublishedDraft: false
    });
const $604fac8d946e92cb$export$752310dc6b894807 = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "copy-page",
        onClick: ()=>{
            dialogs.showModal((0, $5FwhF.CopyPageTreeDialog), {
                contentId: contentId,
                spaceKey: spaceKey
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.copy));
const $604fac8d946e92cb$export$b945ccaa4d42d330 = ({ webItems: webItems, isSubMenuOpen: isSubMenuOpen, handleMouseEnter: handleMouseEnter, handleClick: handleClick, onOpenChange: onOpenChange })=>{
    const exportItems = webItems.filter((item)=>item.id === 'action-export-pdf-link' || item.id === 'action-export-word-link');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $93ydA.ExpandableSubMenuItem), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.export),
        items: exportItems,
        isSubMenuOpen: isSubMenuOpen,
        onMouseEnter: handleMouseEnter,
        onClick: handleClick,
        onOpenChange: onOpenChange
    });
};
const $604fac8d946e92cb$export$b0891f8ed710dfea = ({ webItems: webItems })=>{
    const historyLinkItem = webItems.find((item)=>item.id === 'action-view-history-link');
    if (!historyLinkItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "page-history",
        href: historyLinkItem.url || ''
    }, historyLinkItem.label);
};
const $604fac8d946e92cb$export$974c86dc01d0ca75 = ({ contentId: contentId, spaceKey: spaceKey, webItems: webItems, isSubMenuOpen: isSubMenuOpen, handleMouseEnter: handleMouseEnter, handleClick: handleClick, onOpenChange: onOpenChange })=>{
    const intl = (0, $dBxQj.default)();
    const attachmentsItem = webItems.find((item)=>item.id === 'view-attachments-link');
    const items = [];
    if (attachmentsItem) {
        // extract attachments count from label
        const attachmentsCountStr = attachmentsItem?.label?.match($604fac8d946e92cb$var$numbersRegex)?.[0] ?? '';
        attachmentsItem.badgeLabel = attachmentsCountStr;
        // relabel attachments to files
        attachmentsItem.label = intl.formatMessage($604fac8d946e92cb$export$ba79d07cc96b64e3.files);
        items.push(attachmentsItem);
        const sectionItemForCustomContents = {
            id: 'view-custom-contents-link',
            label: intl.formatMessage($604fac8d946e92cb$export$ba79d07cc96b64e3.customContents),
            url: (0, $1NBp8.CUSTOM_CONTENTS_ON_PAGE_LIST).toUrl({
                contentId: contentId,
                spaceKey: spaceKey
            })
        };
        items.push(sectionItemForCustomContents);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $93ydA.ExpandableSubMenuItem), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.attachments),
        items: items,
        isSubMenuOpen: isSubMenuOpen,
        onMouseEnter: handleMouseEnter,
        onClick: handleClick,
        onOpenChange: onOpenChange
    });
};
const $604fac8d946e92cb$export$59a3c28f917ceccb = ({ contentId: contentId, dialogs: dialogs, webItems: webItems })=>{
    const deleteLinkItem = webItems.find((item)=>item.id === 'action-remove-content-link');
    if (!deleteLinkItem) return null;
    const contentType = 'page';
    const handleDeleteClick = ()=>{
        dialogs.showModal((0, $kDxvw.DeleteNestedPagesActionLoader), {
            contentId: contentId,
            source: $604fac8d946e92cb$var$analyticsSource,
            shouldRedirectOnSuccess: true,
            contentType: contentType
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "delete",
        onClick: handleDeleteClick
    }, deleteLinkItem.label);
};
const $604fac8d946e92cb$export$d3300574d10089ff = ({ webItems: webItems })=>{
    const analyticsLinkItem = webItems.find((item)=>item.id === (0, $hFGQl.ANALYTICS_ADDON_ACTIONS_MENU_ID));
    if (!analyticsLinkItem) return null;
    // Replace the WebItem URL with the new native UI route URL while keeping the query params
    const url = (0, $3Syas.pageAnalyticsUrlToRouteUrl)(analyticsLinkItem.url);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iff8m.AnalyticsPluginWrapper), {
        webItemId: analyticsLinkItem.id,
        key: analyticsLinkItem.completeKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        href: url,
        ...analyticsLinkItem
    }, analyticsLinkItem.label));
};
const $604fac8d946e92cb$export$79990175e7fcba3a = ({ webItems: webItems, contentId: contentId, closeMenu: closeMenu, isOpen: isOpen, onClick: onClick, onMouseEnter: onMouseEnter, closePopup: closePopup })=>{
    const pageOwnerItem = webItems.find((item)=>item.id === (0, $2E1L5.CONTENT_OWNERSHIP_WEB_ITEM_ID));
    if (!pageOwnerItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jcM8h.ContentOwnerPopupComponent), {
        contentId: contentId,
        itemId: pageOwnerItem.id,
        itemLabel: pageOwnerItem.label,
        onCloseParent: closeMenu,
        isOpen: isOpen,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onClosePopup: closePopup
    });
};
const $604fac8d946e92cb$export$b037fbb835bc6c32 = ({ webItems: webItems, isSubMenuOpen: isSubMenuOpen, handleMouseEnter: handleMouseEnter, handleClick: handleClick, onOpenChange: onOpenChange })=>{
    const ids = [
        'link-to-page-link',
        'view-page-info-link',
        'action-view-source-link',
        'view-in-hierarchy-link',
        'action-view-storage-link',
        'content-api',
        'import-word-doc',
        'end-of-page-recommendation-menu'
    ];
    const subItems = webItems.filter((item)=>ids.includes(item.id));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $93ydA.ExpandableSubMenuItem), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.advanced),
        items: subItems,
        isSubMenuOpen: isSubMenuOpen,
        onMouseEnter: handleMouseEnter,
        onClick: handleClick,
        onOpenChange: onOpenChange
    });
};
const $604fac8d946e92cb$export$580a6a510077d1e2 = ({ webItems: webItems, contentId: contentId, dialogs: dialogs })=>{
    const archiveLinkId = 'action-archive-link';
    const archiveLinkItem = webItems.find((item)=>item.id === archiveLinkId);
    const handleArchiveMenuClick = (edition)=>{
        if (edition !== (0, $euL71.ConfluenceEdition).FREE) dialogs.showModal((0, $8WXru.ArchivePagesLoader), {
            contentId: contentId,
            source: 'contentToolsItem'
        });
        else dialogs.showModal((0, $8WXru.ArchiveUpsellDialog));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ edition: edition })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), {
            query: (0, $6UxbI.ShowArchiveCTAQuery),
            variables: {
                contentId: contentId
            }
        }, ({ loading: loading, error: error, data: data })=>{
            const operations = data?.content?.nodes?.[0]?.operations;
            if (loading) return null;
            else if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
                error: error
            });
            else if (edition === (0, $euL71.ConfluenceEdition).FREE || operations !== null && (0, $5gFHQ.canUnarchivePage)(operations)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                key: archiveLinkItem.completeKey,
                onClick: ()=>handleArchiveMenuClick(edition)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.archive));
            else return null;
        }));
};
const $604fac8d946e92cb$export$ad35a31d7a6df26d = ({ onClickOpenContentCreationPanel: onClickOpenContentCreationPanel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        onClick: onClickOpenContentCreationPanel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $6DX3n.i18n).templateImportDocs));
const $604fac8d946e92cb$export$7719ee501ebfc920 = ({ webItems: webItems, isSubMenuOpen: isSubMenuOpen, handleMouseEnter: handleMouseEnter, handleClick: handleClick, forgeMenuItems: forgeMenuItems, onOpenChange: onOpenChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lI54U.PageAppsExpandableSubMenuItems), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.pageApps),
        items: webItems,
        isSubMenuOpen: isSubMenuOpen,
        onMouseEnter: handleMouseEnter,
        onClick: handleClick,
        forgeMenuItems: forgeMenuItems,
        onOpenChange: onOpenChange
    });
const $604fac8d946e92cb$export$8bc386a38f677f82 = (contentId)=>{
    const spaceId = (0, $7QM6o.useSpaceId)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ theme: theme }] = (0, $7J5Uc.useThemingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ({ enterPresenterMode: enterPresenterMode, isTriggedByKeyboardShortcut: isTriggedByKeyboardShortcut = false })=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'present',
                    source: 'LivePagesEllipsisMenuItems',
                    objectId: contentId,
                    containerId: spaceId,
                    attributes: {
                        currentThemePreference: theme,
                        OStheme: (0, $5yVAS.getSystemPreferredColorScheme)(),
                        isTriggedByKeyboardShortcut: isTriggedByKeyboardShortcut
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
            enterPresenterMode();
        };
};
const $604fac8d946e92cb$export$6cbf3f551981c306 = ({ webItems: webItems, contentId: contentId })=>{
    const presenterModeId = 'presentation-mode';
    const presenterModeItem = webItems.find((item)=>item.id === presenterModeId);
    const enterPresenterModeAndStartExperience = $604fac8d946e92cb$export$8bc386a38f677f82(contentId);
    if (!presenterModeItem) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).COMMENTS,
        key: presenterModeItem.completeKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5KL6w.LazyPresenterModeContextConsumer), {
        key: `presenter-mode-menu-item-${presenterModeItem.completeKey}`
    }, (enterPresenterMode)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: presenterModeId,
            onClick: enterPresenterModeAndStartExperience({
                enterPresenterMode: enterPresenterMode
            }),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3KUzn))), {
                label: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $604fac8d946e92cb$export$ba79d07cc96b64e3.presenterMode))));
};

});
parcelRegister("3KUzn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8cbf4ab2d75c385e37fe01f50c4f5b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2bc18c843d1b28df$var$_react = $2bc18c843d1b28df$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $2bc18c843d1b28df$var$_baseNew = $2bc18c843d1b28df$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $2bc18c843d1b28df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2bc18c843d1b28df$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $2bc18c843d1b28df$var$_react.default.createElement($2bc18c843d1b28df$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.629.896-2.277a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$2bc18c843d1b28df$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $2bc18c843d1b28df$var$_default = module.exports.default = $2bc18c843d1b28df$var$PresenterModeIcon;

});

parcelRegister("8WXru", function(module, exports) {

$parcel$export(module.exports, "ArchivedPageBanner", () => $6f4b0ae28e5cb1a2$export$a32ab742d345a2c9);
$parcel$export(module.exports, "ArchivePagesLoader", () => $6f4b0ae28e5cb1a2$export$baebba9f0bb9158);
$parcel$export(module.exports, "ArchiveUpsellDialog", () => $6f4b0ae28e5cb1a2$export$8cf79fbd47bc14c3);
$parcel$export(module.exports, "UnarchivePagesDialogLoader", () => $6f4b0ae28e5cb1a2$export$9c05e92142f10f44);
$parcel$export(module.exports, "BulkArchivePagesLoader", () => $6f4b0ae28e5cb1a2$export$3ef64b4ca9fc58eb);
$parcel$export(module.exports, "UpdateArchivedPageNoteDialog", () => $6f4b0ae28e5cb1a2$export$90092c26537d33ce);
$parcel$export(module.exports, "CONTENT_STATUS_ARCHIVED", () => (parcelRequire("aqBZ0")).CONTENT_STATUS_ARCHIVED);
$parcel$export(module.exports, "fireUIClickEvent", () => (parcelRequire("12UWa")).fireUIClickEvent);
$parcel$export(module.exports, "ShowArchiveCTAQuery", () => (parcelRequire("6UxbI")).ShowArchiveCTAQuery);
$parcel$export(module.exports, "canUnarchivePage", () => (parcelRequire("5gFHQ")).canUnarchivePage);
$parcel$export(module.exports, "ArchivedPageNoteInput", () => (parcelRequire("lkMYF")).ArchivedPageNoteInput);

var $jmjWc = parcelRequire("jmjWc");

var $aqBZ0 = parcelRequire("aqBZ0");


var $12UWa = parcelRequire("12UWa");

var $6UxbI = parcelRequire("6UxbI");

var $5gFHQ = parcelRequire("5gFHQ");

var $lkMYF = parcelRequire("lkMYF");

const $6f4b0ae28e5cb1a2$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pHSY4",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("8sWiZ"))).ArchivedPageBanner
});

const $6f4b0ae28e5cb1a2$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3XXQ9",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("h43qv"))).ArchivePagesLoader
});

const $6f4b0ae28e5cb1a2$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NigbK",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("ls7N6"))).ArchiveUpsellDialog
});

const $6f4b0ae28e5cb1a2$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KCCTH",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("c1Y54"))).UnarchivePagesLoader
});

const $6f4b0ae28e5cb1a2$export$3ef64b4ca9fc58eb = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CzQm5",
    name: "BulkArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("7berd"))).BulkArchivePagesLoader
});

const $6f4b0ae28e5cb1a2$export$a328be585833b9ad = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IyPAI",
    name: "ArchiveRemoteProcessContainer",
    loader: async ()=>(await (parcelRequire("5wnAr"))).ArchiveRemoteProcessContainer
});

const $6f4b0ae28e5cb1a2$export$90092c26537d33ce = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3LYWa",
    name: "UpdateArchivedPageNoteDialog",
    loader: async ()=>(await (parcelRequire("8jOz2"))).UpdateArchivedPageNoteDialog
});

});
parcelRegister("aqBZ0", function(module, exports) {

$parcel$export(module.exports, "CONTENT_STATUS_ARCHIVED", () => $1f65bcd6ebccf55c$export$41b2e06f27dfe96e);
$parcel$export(module.exports, "ARCHIVE_INTL_PREFIX", () => $1f65bcd6ebccf55c$export$e2153f1ee0381860);
$parcel$export(module.exports, "UNARCHIVE_INTL_PREFIX", () => $1f65bcd6ebccf55c$export$c8e98879124fb1f0);
$parcel$export(module.exports, "ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT", () => $1f65bcd6ebccf55c$export$781b73bccf46ba2c);
$parcel$export(module.exports, "BULK_ARCHIVE_PAGE_SELECTION_LIMIT", () => $1f65bcd6ebccf55c$export$ab874a69c0b17d25);
$parcel$export(module.exports, "ArchiveStatus", () => $1f65bcd6ebccf55c$export$ca079fdb822b790f);
$parcel$export(module.exports, "PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK", () => $1f65bcd6ebccf55c$export$a2742df05b19b873);
$parcel$export(module.exports, "ARCHIVE_PERMISSIONS_SUPPORT_LINK", () => $1f65bcd6ebccf55c$export$9de02bef22980fc);
$parcel$export(module.exports, "UNARCHIVE_PERMISSIONS_SUPPORT_LINK", () => $1f65bcd6ebccf55c$export$45c8fb669461b6d5);
const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';

});

parcelRegister("12UWa", function(module, exports) {

$parcel$export(module.exports, "getActionName", () => $d42c1236b5cc8ac8$export$d569af9d235186c9);
$parcel$export(module.exports, "fireUIClickEvent", () => $d42c1236b5cc8ac8$export$5edee710fd3e881c);
$parcel$export(module.exports, "fireTrackEvent", () => $d42c1236b5cc8ac8$export$574d2f19a52d67ca);
$parcel$export(module.exports, "fireScreenEvent", () => $d42c1236b5cc8ac8$export$59608e0169622110);
const $d42c1236b5cc8ac8$export$d569af9d235186c9 = (isArchive, isBulk = false)=>isArchive ? isBulk ? 'bulkArchive' : 'archive' : isBulk ? 'bulkRestore' : 'restore';
const $d42c1236b5cc8ac8$export$a1562d08625f5d7e = 'sendUIEvent';
const $d42c1236b5cc8ac8$export$947dac6c72b26f81 = 'sendTrackEvent';
const $d42c1236b5cc8ac8$export$c2f50b86729b5b74 = 'selectDropdown';
const $d42c1236b5cc8ac8$export$fedfc172a3b39723 = 'spaceSelect';
const $d42c1236b5cc8ac8$export$79fc012ce0853550 = 'button';
const $d42c1236b5cc8ac8$export$7eca133280843f9e = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$a1562d08625f5d7e
    });
const $d42c1236b5cc8ac8$export$5edee710fd3e881c = (eventProps)=>$d42c1236b5cc8ac8$export$7eca133280843f9e({
        ...eventProps,
        action: 'clicked'
    });
const $d42c1236b5cc8ac8$export$574d2f19a52d67ca = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$947dac6c72b26f81
    });
const $d42c1236b5cc8ac8$export$59608e0169622110 = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: 'sendScreenEvent'
    });
const $d42c1236b5cc8ac8$export$3e13615bb023ad8f = (params)=>{
    const { createAnalyticsEvent: createAnalyticsEvent, type: type, ...data } = params;
    createAnalyticsEvent({
        type: type,
        data: data
    }).fire();
};

});

parcelRegister("6UxbI", function(module, exports) {

$parcel$export(module.exports, "ShowArchiveCTAQuery", () => $618c965d6b707606$export$48d989c744802bc9);

var $d2LG0 = parcelRequire("d2LG0");
const $618c965d6b707606$export$48d989c744802bc9 = (0, $d2LG0.default)`query ShowArchiveCTAQuery($contentId:ID!){content(id:$contentId){nodes{id operations{operation targetType}}}}`;

});

parcelRegister("5gFHQ", function(module, exports) {

$parcel$export(module.exports, "canUnarchivePage", () => $55ad5daf9125a00c$export$a005804086228029);

var $3UO79 = parcelRequire("3UO79");
const $55ad5daf9125a00c$export$a005804086228029 = (operations)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($3UO79)))(operations, {
        targetType: 'page',
        operation: 'archive'
    });
};
const $55ad5daf9125a00c$export$3c5f398ac6d45bea = (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($3UO79)))(operations, {
        targetType: 'page',
        operation: 'delete'
    });

});
parcelRegister("3UO79", function(module, exports) {

var $gl9Fx = parcelRequire("gl9Fx");

var $9lCvb = parcelRequire("9lCvb");

var $aJBPG = parcelRequire("aJBPG");

var $7k59M = parcelRequire("7k59M");

var $g1CM8 = parcelRequire("g1CM8");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $2d9d79b87a1fa048$var$some(collection, predicate, guard) {
    var func = $7k59M(collection) ? $gl9Fx : $aJBPG;
    if (guard && $g1CM8(collection, predicate, guard)) predicate = undefined;
    return func(collection, $9lCvb(predicate, 3));
}
module.exports = $2d9d79b87a1fa048$var$some;

});
parcelRegister("aJBPG", function(module, exports) {

var $eCKpe = parcelRequire("eCKpe");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7d0b741c6ee260b0$var$baseSome(collection, predicate) {
    var result;
    $eCKpe(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $7d0b741c6ee260b0$var$baseSome;

});



parcelRegister("lkMYF", function(module, exports) {

$parcel$export(module.exports, "ArchivedPageNoteInput", () => $2a95076628c8a6f5$export$ccf9d1c1733e8c09);
/* ArchivedPageNoteInput.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $iEKnc = parcelRequire("iEKnc");

var $9EtP6 = parcelRequire("9EtP6");

var $inPa6 = parcelRequire("inPa6");

var $7gpC4 = parcelRequire("7gpC4");

var $fzqvY = parcelRequire("fzqvY");
var $fb3kw = parcelRequire("fb3kw");
var $gQhRa = parcelRequire("gQhRa");

var $12UWa = parcelRequire("12UWa");

var $aqBZ0 = parcelRequire("aqBZ0");
const $2a95076628c8a6f5$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    notePlaceholder: {
        id: "archive-pages.archive.dialog.note.placeholder",
        defaultMessage: "Let others know why this was archived."
    },
    noteTitle: {
        id: "archive-pages.archive.dialog.note.title",
        defaultMessage: "Note (optional)"
    },
    applyNoteToNestedPagesLabel: {
        id: "archive-pages.archive.dialog.note.apply-note-to-nested-message",
        defaultMessage: "Add note to nested items, too"
    },
    characterLimitError: {
        id: "archive-pages.archive.dialog.note.character-limit-error-message",
        defaultMessage: "You exceeded the character limit."
    }
});
const $2a95076628c8a6f5$var$nestedCheckboxWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a95076628c8a6f5$var$InverseLabelColor = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "",
            __cmplp?.isColorInverted && "_syaz15cr",
            __cmplp.className
        ])
    });
});
const $2a95076628c8a6f5$var$ErrorWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw",
            __cmplp?.isColorInverted ? "_syazs99h" : "_syaz1tmw",
            __cmplp.className
        ])
    });
});
const $2a95076628c8a6f5$var$ArchivedPageNoteInputComponent = ({ noteRef: noteRef, includeNestedCheckbox: includeNestedCheckbox, onNestedCheckboxChange: onNestedCheckboxChange, isNestedCheckboxChecked: isNestedCheckboxChecked, analyticsSource: analyticsSource, defaultValue: defaultValue, intl: intl, onValidate: onValidate = ()=>{}, isColorInverted: isColorInverted, isArchiveInProgress: isArchiveInProgress })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [hasNote, setHasNote] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        noteRef.current?.focus(); // Move cursor to the end
        const noteLength = noteRef.current?.value?.length || 0;
        noteRef.current?.setSelectionRange(noteLength, noteLength);
    }, [
        noteRef
    ]);
    (0, $gwFzn.useEffect)(()=>{
        (0, $12UWa.fireScreenEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            name: analyticsSource
        });
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    const characterLimit = (0, $aqBZ0.ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT);
    const validate = (value)=>{
        setHasNote(!!value);
        const isValid = value && value.length <= characterLimit || !value;
        onValidate(isValid);
        if (!isValid) return 'CHAR_LIMIT_EXCEEDED';
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fzqvY.default), {
        onSubmit: ()=>{}
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fb3kw.default), {
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2a95076628c8a6f5$var$InverseLabelColor, {
                isColorInverted: isColorInverted
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $2a95076628c8a6f5$export$a7357cdd1f0b0168.noteTitle)),
            name: "note",
            validate: validate,
            defaultValue: defaultValue
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9EtP6.default), {
                ref: noteRef,
                placeholder: intl.formatMessage($2a95076628c8a6f5$export$a7357cdd1f0b0168.notePlaceholder),
                minimumRows: 1,
                ...fieldProps,
                name: "ArchivedPageNoteInput-TextArea",
                isDisabled: isArchiveInProgress
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2a95076628c8a6f5$var$InverseLabelColor, {
                isColorInverted: isColorInverted
            }, fieldProps.value ? fieldProps.value.length : 0, "/", characterLimit)), error === 'CHAR_LIMIT_EXCEEDED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gQhRa.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($2a95076628c8a6f5$var$ErrorWrapper, {
                isColorInverted: isColorInverted
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iEKnc))), {
                label: "error"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $2a95076628c8a6f5$export$a7357cdd1f0b0168.characterLimitError))), includeNestedCheckbox && hasNote && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $2a95076628c8a6f5$var$nestedCheckboxWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7gpC4.default), {
                label: intl.formatMessage($2a95076628c8a6f5$export$a7357cdd1f0b0168.applyNoteToNestedPagesLabel),
                onChange: onNestedCheckboxChange,
                isChecked: isNestedCheckboxChecked,
                testId: "cb-apply-note-nested-pages"
            })))))));
};
const $2a95076628c8a6f5$export$ccf9d1c1733e8c09 = (0, $js7oX.default)($2a95076628c8a6f5$var$ArchivedPageNoteInputComponent);

});

parcelRegister("8sWiZ", function(module, exports) {

let $629e2a73ad5d010b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $629e2a73ad5d010b$var$load("7dkWW"),
    $629e2a73ad5d010b$var$load("6rpul")
]).then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("h43qv", function(module, exports) {

let $c6c577d01809439b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c6c577d01809439b$var$load("bKdog"),
    $c6c577d01809439b$var$load("8eNS3"),
    $c6c577d01809439b$var$load("50LrB"),
    $c6c577d01809439b$var$load("kDklq"),
    $c6c577d01809439b$var$load("cQ2OK"),
    $c6c577d01809439b$var$load("77pyi"),
    $c6c577d01809439b$var$load("4gtMV"),
    $c6c577d01809439b$var$load("h4Nf7"),
    $c6c577d01809439b$var$load("f96v0"),
    $c6c577d01809439b$var$load("ev7SX"),
    $c6c577d01809439b$var$load("gQSWJ"),
    $c6c577d01809439b$var$load("5tHTv"),
    $c6c577d01809439b$var$load("4fCJZ"),
    $c6c577d01809439b$var$load("aZinD"),
    $c6c577d01809439b$var$load("4aLlP"),
    $c6c577d01809439b$var$load("6qah4"),
    $c6c577d01809439b$var$load("c6MKV"),
    $c6c577d01809439b$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("ls7N6", function(module, exports) {

let $f9e241a284776f94$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $f9e241a284776f94$var$load("7rEYM"),
    $f9e241a284776f94$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("c1Y54", function(module, exports) {

let $8c242ed199e72846$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $8c242ed199e72846$var$load("bKdog"),
    $8c242ed199e72846$var$load("8eNS3"),
    $8c242ed199e72846$var$load("50LrB"),
    $8c242ed199e72846$var$load("kDklq"),
    $8c242ed199e72846$var$load("cQ2OK"),
    $8c242ed199e72846$var$load("7WcBh"),
    $8c242ed199e72846$var$load("77pyi"),
    $8c242ed199e72846$var$load("4gtMV"),
    $8c242ed199e72846$var$load("h4Nf7"),
    $8c242ed199e72846$var$load("f96v0"),
    $8c242ed199e72846$var$load("ev7SX"),
    $8c242ed199e72846$var$load("2Fobu"),
    $8c242ed199e72846$var$load("gQSWJ"),
    $8c242ed199e72846$var$load("5tHTv"),
    $8c242ed199e72846$var$load("4fCJZ"),
    $8c242ed199e72846$var$load("aZinD"),
    $8c242ed199e72846$var$load("4aLlP"),
    $8c242ed199e72846$var$load("6qah4"),
    $8c242ed199e72846$var$load("c6MKV"),
    $8c242ed199e72846$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("7berd", function(module, exports) {

let $53a4c292e54dc0e1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $53a4c292e54dc0e1$var$load("cQ2OK"),
    $53a4c292e54dc0e1$var$load("4gtMV"),
    $53a4c292e54dc0e1$var$load("c6MKV"),
    $53a4c292e54dc0e1$var$load("anGwD")
]).then(()=>parcelRequire('1nPts'));

});

parcelRegister("5wnAr", function(module, exports) {

let $40523cb9ed894a0c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $40523cb9ed894a0c$var$load("cQ2OK"),
    $40523cb9ed894a0c$var$load("c6MKV"),
    $40523cb9ed894a0c$var$load("f0OaY")
]).then(()=>parcelRequire('bkgW7'));

});

parcelRegister("8jOz2", function(module, exports) {

let $60e75213e4a4e522$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $60e75213e4a4e522$var$load("cQ2OK"),
    $60e75213e4a4e522$var$load("7dkWW"),
    $60e75213e4a4e522$var$load("4gtMV"),
    $60e75213e4a4e522$var$load("c6MKV"),
    $60e75213e4a4e522$var$load("hVNnP")
]).then(()=>parcelRequire('5Fm8G'));

});


parcelRegister("kDxvw", function(module, exports) {

$parcel$export(module.exports, "DeleteNestedPagesActionLoader", () => $59c18e33f3a476d1$export$25f686fb78162d50);
$parcel$export(module.exports, "BulkDeletePagesActionLoader", () => $59c18e33f3a476d1$export$a423abb15d3d6d30);
$parcel$export(module.exports, "BulkChangeStatusActionLoader", () => $59c18e33f3a476d1$export$bf041026e8eb696b);
$parcel$export(module.exports, "NestedChangeOwnerActionLoader", () => $59c18e33f3a476d1$export$55e2430adfd14e98);
$parcel$export(module.exports, "BulkConvertPageToLiveDocActionLoader", () => $59c18e33f3a476d1$export$79c7cc6a61cdefc7);
$parcel$export(module.exports, "BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT", () => (parcelRequire("abCbd")).BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT);
$parcel$export(module.exports, "getBulkConvertToLiveDocPageLimit", () => (parcelRequire("1QHwx")).getBulkConvertToLiveDocPageLimit);

var $jmjWc = parcelRequire("jmjWc");

var $abCbd = parcelRequire("abCbd");

var $1QHwx = parcelRequire("1QHwx");

var $9wGTI = parcelRequire("9wGTI");

const $59c18e33f3a476d1$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "0nMCr",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("bnwGh"))).DeleteNestedPagesAction
});

const $59c18e33f3a476d1$export$a423abb15d3d6d30 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "dGDo_",
    name: "BulkDeletePagesActionLoader",
    loader: async ()=>(await (parcelRequire("5so4j"))).BulkDeletePagesAction
});

const $59c18e33f3a476d1$export$6b9ae9a535d22c99 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "weQTl",
    name: "BulkChangeOwnerActionLoader",
    loader: async ()=>(await (parcelRequire("1Lxj8"))).BulkChangeOwnerAction
});

const $59c18e33f3a476d1$export$bf041026e8eb696b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Sb9O",
    name: "BulkChangeStatusActionLoader",
    loader: async ()=>(await (parcelRequire("2G9yl"))).BulkChangeStatusAction
});

const $59c18e33f3a476d1$export$55e2430adfd14e98 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tndKr",
    name: "NestedChangeOwnerActionLoader",
    loader: async ()=>(await (parcelRequire("b8rBs"))).NestedChangeOwnerAction
});


const $59c18e33f3a476d1$export$79c7cc6a61cdefc7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "FODyI",
    name: "BulkConvertPageToLiveDocActionLoader",
    loader: async ()=>{
        if ((0, $9wGTI.fg)('a4c-3732-live-doc-conversion-with-bulk-mutation')) return (await (parcelRequire("d3IbQ"))).NestedConvertPageToLiveDocAction;
        else return (await (parcelRequire("5yEey"))).BulkConvertPageToLiveDocAction;
    }
});

});
parcelRegister("abCbd", function(module, exports) {

$parcel$export(module.exports, "ActionStatus", () => $49f30f782ee3886b$export$dde867dc2e19cdfb);
$parcel$export(module.exports, "LINK_TO_SUPPORT_CONTACT", () => $49f30f782ee3886b$export$a047e1504a58a095);
$parcel$export(module.exports, "PAGE_RESTRICTIONS_SUPPORT_LINK", () => $49f30f782ee3886b$export$90622b83e51be397);
$parcel$export(module.exports, "ContentStatus", () => $49f30f782ee3886b$export$b2be22e9d5dd3927);
$parcel$export(module.exports, "BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT", () => $49f30f782ee3886b$export$c047260051351df3);
/* eslint-disable check-file/filename-blocklist */ var $49f30f782ee3886b$export$dde867dc2e19cdfb = /*#__PURE__*/ function(ActionStatus) {
    ActionStatus["LOADING"] = "loading";
    ActionStatus["ERROR"] = "error";
    ActionStatus["SUCCESS"] = "success";
    return ActionStatus;
}({});
const $49f30f782ee3886b$export$a047e1504a58a095 = 'https://support.atlassian.com/contact/#/';
const $49f30f782ee3886b$export$992f6917cca3802d = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/';
const $49f30f782ee3886b$export$f077813e47f96ab7 = 'https://support.atlassian.com/confluence-cloud/docs/delete-restore-or-purge-a-page/';
const $49f30f782ee3886b$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
var $49f30f782ee3886b$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["ARCHIVED"] = "archived";
    ContentStatus["RESTORED"] = "restored";
    // Trashed pages can be restored.
    ContentStatus["TRASHED"] = "trashed";
    return ContentStatus;
}({});
const $49f30f782ee3886b$export$c047260051351df3 = 100;

});

parcelRegister("1QHwx", function(module, exports) {

$parcel$export(module.exports, "getBulkConvertToLiveDocPageLimit", () => $9a02ab1ab3284ce1$export$12d864c24846f407);
/**
 * Hook used in Content Manager bulk action for converting page to live doc.
 */ 
var $4VJDS = parcelRequire("4VJDS");
const $9a02ab1ab3284ce1$var$CONVERT_TO_LIVE_DOC_PAGE_LIMIT_CONFIG = 'confluence_bulk_convert_page_to_live_doc_limit';
// Default values for max number of pages that allowed to select
const $9a02ab1ab3284ce1$var$DEFAULT_PAGE_TO_LIVE_DOC_SELECTION_LIMIT = 50;
// Default values for max number of pages that allowed to convert
const $9a02ab1ab3284ce1$var$DEFAULT_PAGE_TO_LIVE_DOC_CONVERSION_LIMIT = 10;
const $9a02ab1ab3284ce1$export$12d864c24846f407 = ()=>{
    const [selectionLimit, conversionLimit] = (0, $4VJDS.default).getNumberList($9a02ab1ab3284ce1$var$CONVERT_TO_LIVE_DOC_PAGE_LIMIT_CONFIG, [
        $9a02ab1ab3284ce1$var$DEFAULT_PAGE_TO_LIVE_DOC_SELECTION_LIMIT,
        $9a02ab1ab3284ce1$var$DEFAULT_PAGE_TO_LIVE_DOC_CONVERSION_LIMIT
    ]);
    return {
        selectionLimit: selectionLimit,
        conversionLimit: conversionLimit
    };
};

});

parcelRegister("bnwGh", function(module, exports) {

let $848b3171ce269056$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $848b3171ce269056$var$load("adHzf"),
    $848b3171ce269056$var$load("k3BGs"),
    $848b3171ce269056$var$load("77pyi"),
    $848b3171ce269056$var$load("gQSWJ"),
    $848b3171ce269056$var$load("c6MKV"),
    $848b3171ce269056$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("5so4j", function(module, exports) {

let $3f923cce5ca95b97$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3f923cce5ca95b97$var$load("k3BGs"),
    $3f923cce5ca95b97$var$load("4JUnA")
]).then(()=>parcelRequire('11cB0'));

});

parcelRegister("1Lxj8", function(module, exports) {

let $1494046d0f5a849b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1494046d0f5a849b$var$load("adHzf"),
    $1494046d0f5a849b$var$load("k3BGs"),
    $1494046d0f5a849b$var$load("77pyi"),
    $1494046d0f5a849b$var$load("kQvbt"),
    $1494046d0f5a849b$var$load("jQFGH"),
    $1494046d0f5a849b$var$load("fQ1rW"),
    $1494046d0f5a849b$var$load("4tUsp"),
    $1494046d0f5a849b$var$load("h4Nf7"),
    $1494046d0f5a849b$var$load("gQSWJ"),
    $1494046d0f5a849b$var$load("4fCJZ"),
    $1494046d0f5a849b$var$load("9FBaW"),
    $1494046d0f5a849b$var$load("aZinD"),
    $1494046d0f5a849b$var$load("6StWh"),
    $1494046d0f5a849b$var$load("5YvMC")
]).then(()=>parcelRequire('3PdBi'));

});

parcelRegister("2G9yl", function(module, exports) {

let $1f36ea0b1652d9f7$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $1f36ea0b1652d9f7$var$load("k3BGs"),
    $1f36ea0b1652d9f7$var$load("leIbB"),
    $1f36ea0b1652d9f7$var$load("bXkeF")
]).then(()=>parcelRequire('4rgwl'));

});

parcelRegister("b8rBs", function(module, exports) {

let $81b5da7522d6f0aa$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $81b5da7522d6f0aa$var$load("k3BGs"),
    $81b5da7522d6f0aa$var$load("kQvbt"),
    $81b5da7522d6f0aa$var$load("jQFGH"),
    $81b5da7522d6f0aa$var$load("fQ1rW"),
    $81b5da7522d6f0aa$var$load("4tUsp"),
    $81b5da7522d6f0aa$var$load("h4Nf7"),
    $81b5da7522d6f0aa$var$load("4fCJZ"),
    $81b5da7522d6f0aa$var$load("9FBaW"),
    $81b5da7522d6f0aa$var$load("aZinD"),
    $81b5da7522d6f0aa$var$load("6StWh"),
    $81b5da7522d6f0aa$var$load("1aFR7")
]).then(()=>parcelRequire('al9cI'));

});

parcelRegister("d3IbQ", function(module, exports) {

let $981dd56bc5a2a0c9$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $981dd56bc5a2a0c9$var$load("k3BGs"),
    $981dd56bc5a2a0c9$var$load("lgZ1d"),
    $981dd56bc5a2a0c9$var$load("Pp5sV")
]).then(()=>parcelRequire('vRfNK'));

});

parcelRegister("5yEey", function(module, exports) {

let $40bf564ccffabecc$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $40bf564ccffabecc$var$load("k3BGs"),
    $40bf564ccffabecc$var$load("lgZ1d")
]).then(()=>parcelRequire('kYnTG'));

});


parcelRegister("3Syas", function(module, exports) {

$parcel$export(module.exports, "pageAnalyticsUrlToRouteUrl", () => $bd6cd55121384b66$export$3ef1b18b48cd8e50);

var $1NBp8 = parcelRequire("1NBp8");
const $bd6cd55121384b66$export$3ef1b18b48cd8e50 = (relativeUrl)=>{
    if (!relativeUrl) return '';
    // First, extract everything in the relative URL after the '?' in the URL
    const queryParams = new URLSearchParams(relativeUrl.split('?')[1] || '');
    // Extract the space key and content ID from the query params
    const spaceKey = queryParams.get('space.key') || '';
    const contentId = queryParams.get('content.id') || '';
    if (!spaceKey || !contentId) return '';
    return (0, $1NBp8.PAGE_ANALYTICS).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
};

});

parcelRegister("5FwhF", function(module, exports) {

$parcel$export(module.exports, "CopyPageTreeDialog", () => $ee4e9cc4db58f73d$export$b3f442789ed34bf1);

var $jmjWc = parcelRequire("jmjWc");

const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("gOvUs"))).CopyPageTreeContainer
});

});
parcelRegister("gOvUs", function(module, exports) {

let $c3da116a4952bb2d$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c3da116a4952bb2d$var$load("fOLlY"),
    $c3da116a4952bb2d$var$load("58UdM"),
    $c3da116a4952bb2d$var$load("4Qstt"),
    $c3da116a4952bb2d$var$load("5odbj"),
    $c3da116a4952bb2d$var$load("1ZoPC"),
    $c3da116a4952bb2d$var$load("hY77v"),
    $c3da116a4952bb2d$var$load("7WcBh"),
    $c3da116a4952bb2d$var$load("iLLJH"),
    $c3da116a4952bb2d$var$load("2Fobu"),
    $c3da116a4952bb2d$var$load("l1Fa8"),
    $c3da116a4952bb2d$var$load("aDDhU"),
    $c3da116a4952bb2d$var$load("2S1L6"),
    $c3da116a4952bb2d$var$load("U7y88"),
    $c3da116a4952bb2d$var$load("fEx3B"),
    $c3da116a4952bb2d$var$load("dJQEi"),
    $c3da116a4952bb2d$var$load("aZinD"),
    $c3da116a4952bb2d$var$load("6qah4"),
    $c3da116a4952bb2d$var$load("j4gWN"),
    $c3da116a4952bb2d$var$load("i5Fj1"),
    $c3da116a4952bb2d$var$load("c6MKV"),
    $c3da116a4952bb2d$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});


parcelRegister("v1jQ6", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButtonLoader", () => $163bb5cb9a2af796$export$bb4636d2bf564dee);

var $5RlDR = parcelRequire("5RlDR");
const $163bb5cb9a2af796$export$bb4636d2bf564dee = (0, $5RlDR.EditorMovePageButton);

});
parcelRegister("5RlDR", function(module, exports) {

$parcel$export(module.exports, "EditorMovePageButton", () => $34016fb8fb167321$export$65b66e3b59bd4f0);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $ipPpS = parcelRequire("ipPpS");

var $diswb = parcelRequire("diswb");

var $dAYOx = parcelRequire("dAYOx");

var $3gadb = parcelRequire("3gadb");

var $4KS7f = parcelRequire("4KS7f");

var $inPa6 = parcelRequire("inPa6");

var $bbp3G = parcelRequire("bbp3G");

var $dIouf = parcelRequire("dIouf");

var $bHd1w = parcelRequire("bHd1w");

var $78wUU = parcelRequire("78wUU");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $fcURH = parcelRequire("fcURH");
const $34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs = ({ spaceKey: spaceKey, contentId: contentId, appearance: appearance = 'dropdownItem', analyticsSource: analyticsSource, dialogs: dialogs, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isUnpublishedDraft: isUnpublishedDraft })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $d2LG0.default)`query EditorMovePageButtonQuery($contentId:ID!){content(id:$contentId status:["current" "draft"]){nodes{id type status operations{operation targetType}}}}`, {
        variables: {
            contentId: contentId
        },
        displayName: 'EditorMovePageButtonQuery'
    });
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    if (loading) return null;
    const content = data?.content?.nodes?.[0];
    const contentType = content?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const canMoveContent = isUnpublishedDraft || contentType === 'page' || !!operations.find((op)=>op?.targetType === contentType && op?.operation === 'delete');
    const openMoveModal = ()=>{
        if (contentType === 'page') {
            experienceTracker.start({
                name: (0, $irVI7.MOVE_PAGE_DIALOG_LOAD_EXPERIENCE)
            });
            dialogs.showModal((0, $bHd1w.MovePageDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                isMovingDraftVersion: true,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'page'
                }
            }).fire();
        } else if (contentType === 'blogpost') {
            dialogs.showModal((0, $78wUU.MoveBlogModalLoader), {
                currentSpaceKey: spaceKey,
                blogPostId: contentId,
                isEditMode: true,
                isUnpublishedDraft: isUnpublishedDraft,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                referrer: 'editor-move-page-button'
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'openEditorMovePageDialog',
                    source: analyticsSource,
                    objectId: contentId,
                    objectType: 'blog'
                }
            }).fire();
        }
    };
    let component;
    // if FF is on we should show move button for both blog and page types and for both publish and unpublish states
    if (canMoveContent || isUnpublishedDraft && contentType === 'page') {
        if (appearance === 'iconButton') {
            const icon = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                className: "icon aui-icon aui-icon-small aui-iconfont-nav-children"
            });
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
                tag: "span",
                content: intl.formatMessage((0, $fcURH.i18n).movePageBtnDesc)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
                testId: "move-page-icon-button",
                iconBefore: icon,
                appearance: "subtle",
                onClick: openMoveModal
            }));
        } else if (appearance === 'dropdownItem') component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            onClick: openMoveModal,
            testId: "move-page-dropdown-item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), (0, $fcURH.i18n).movePageBtnDesc));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "move-page-button"
    }, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }), component);
};
const $34016fb8fb167321$export$65b66e3b59bd4f0 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
        to: [
            (0, $bbp3G.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($34016fb8fb167321$var$EditorMovePageButtonComponentWithDialogs, {
            ...props,
            dialogs: dialogs
        }));
};

});
parcelRegister("bHd1w", function(module, exports) {

$parcel$export(module.exports, "MovePageDialog", () => $4f760397570928c6$export$28f6951b4656036e);

var $jmjWc = parcelRequire("jmjWc");

const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("9yEkr"))).MovePageDialog
});

});
parcelRegister("9yEkr", function(module, exports) {

let $6f56927f00b4a09b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $6f56927f00b4a09b$var$load("fOLlY"),
    $6f56927f00b4a09b$var$load("58UdM"),
    $6f56927f00b4a09b$var$load("4Qstt"),
    $6f56927f00b4a09b$var$load("5odbj"),
    $6f56927f00b4a09b$var$load("1ZoPC"),
    $6f56927f00b4a09b$var$load("hY77v"),
    $6f56927f00b4a09b$var$load("7WcBh"),
    $6f56927f00b4a09b$var$load("2irg6"),
    $6f56927f00b4a09b$var$load("iLLJH"),
    $6f56927f00b4a09b$var$load("5zDuS"),
    $6f56927f00b4a09b$var$load("2Fobu"),
    $6f56927f00b4a09b$var$load("2YKx2"),
    $6f56927f00b4a09b$var$load("26IOy"),
    $6f56927f00b4a09b$var$load("2nuqm"),
    $6f56927f00b4a09b$var$load("l1Fa8"),
    $6f56927f00b4a09b$var$load("aDDhU"),
    $6f56927f00b4a09b$var$load("2S1L6"),
    $6f56927f00b4a09b$var$load("U7y88"),
    $6f56927f00b4a09b$var$load("fEx3B"),
    $6f56927f00b4a09b$var$load("dJQEi"),
    $6f56927f00b4a09b$var$load("6qah4"),
    $6f56927f00b4a09b$var$load("j4gWN"),
    $6f56927f00b4a09b$var$load("hTb35"),
    $6f56927f00b4a09b$var$load("87F9B"),
    $6f56927f00b4a09b$var$load("aZinD"),
    $6f56927f00b4a09b$var$load("hrAMe"),
    $6f56927f00b4a09b$var$load("i5Fj1"),
    $6f56927f00b4a09b$var$load("c6MKV"),
    $6f56927f00b4a09b$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});


parcelRegister("78wUU", function(module, exports) {

$parcel$export(module.exports, "MoveBlogModalLoader", () => $745e4e253bb54f50$export$fbea3c6f057d30b6);

var $jmjWc = parcelRequire("jmjWc");

const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("gGzSD"))).MoveBlogModal
});

});
parcelRegister("gGzSD", function(module, exports) {

let $c25c66a276a4fdd8$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c25c66a276a4fdd8$var$load("58UdM"),
    $c25c66a276a4fdd8$var$load("4Qstt"),
    $c25c66a276a4fdd8$var$load("5odbj"),
    $c25c66a276a4fdd8$var$load("1ZoPC"),
    $c25c66a276a4fdd8$var$load("hY77v"),
    $c25c66a276a4fdd8$var$load("26IOy"),
    $c25c66a276a4fdd8$var$load("2nuqm"),
    $c25c66a276a4fdd8$var$load("l1Fa8"),
    $c25c66a276a4fdd8$var$load("aDDhU"),
    $c25c66a276a4fdd8$var$load("2S1L6"),
    $c25c66a276a4fdd8$var$load("U7y88"),
    $c25c66a276a4fdd8$var$load("fEx3B"),
    $c25c66a276a4fdd8$var$load("dJQEi"),
    $c25c66a276a4fdd8$var$load("aZinD"),
    $c25c66a276a4fdd8$var$load("6qah4"),
    $c25c66a276a4fdd8$var$load("j4gWN"),
    $c25c66a276a4fdd8$var$load("i5Fj1"),
    $c25c66a276a4fdd8$var$load("c6MKV"),
    $c25c66a276a4fdd8$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});


parcelRegister("fcURH", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $0ac47e05aff110d2$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $0ac47e05aff110d2$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    movePageBtnDesc: {
        id: "editor-move-page-button.move.page.description",
        defaultMessage: "Move"
    }
});

});



parcelRegister("k0pnk", function(module, exports) {

$parcel$export(module.exports, "EditLabelDropdownItem", () => $bb6d2606da8fa2b2$export$207a057b55bce66d);

var $gwFzn = parcelRequire("gwFzn");

var $dAYOx = parcelRequire("dAYOx");

var $88KVZ = parcelRequire("88KVZ");

var $4vaoM = parcelRequire("4vaoM");
const $bb6d2606da8fa2b2$export$207a057b55bce66d = ({ contentId: contentId, spaceKey: spaceKey, dialogs: dialogs })=>{
    const buttonText = (0, $88KVZ.useLabelsDescriptionText)({
        contentId: contentId
    });
    const showEditLabelDialog = ()=>{
        const dialogProps = {
            contentId: contentId,
            spaceKey: spaceKey,
            source: 'fabricEditor'
        };
        dialogs.showModal((0, $4vaoM.EditLabelDialogLoader), dialogProps);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
        key: "edit-labels",
        onClick: showEditLabelDialog
    }, buttonText);
};

});
parcelRegister("88KVZ", function(module, exports) {

$parcel$export(module.exports, "useLabelsDescriptionText", () => $e7b359a64ad828f1$export$45bed9d3e3f6648d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $hp2SH = parcelRequire("hp2SH");

var $eDV4X = parcelRequire("eDV4X");

var $cUIkM = parcelRequire("cUIkM");
const $e7b359a64ad828f1$var$i18n = (0, $2nPZH.defineMessages)({
    edit: {
        id: "labels.modal.title.edit-label",
        defaultMessage: "Edit labels"
    },
    add: {
        id: "labels.modal.title.add-label",
        defaultMessage: "Add labels"
    }
});
const $e7b359a64ad828f1$export$45bed9d3e3f6648d = ({ contentId: contentId, contentType: contentType, labels: labels })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [hasLabels, setHasLabels] = (0, $gwFzn.useState)(null);
    (0, $gwFzn.useEffect)(()=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        async function checkHasLabels() {
            if (contentType === (0, $eDV4X.ContentTypes).TEMPLATE) {
                const labelCount = labels?.length || 0;
                setHasLabels(labelCount > 0);
            } else {
                const { data: data } = await apolloClient.query({
                    query: (0, $cUIkM.LabelsCountQuery),
                    variables: {
                        contentId: contentId,
                        status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
                    }
                });
                setHasLabels(data?.singleContent?.labels?.count > 0);
            }
        }
        checkHasLabels();
    }, [
        contentId,
        contentType,
        labels
    ]);
    return typeof hasLabels === 'boolean' ? formatMessage(hasLabels ? $e7b359a64ad828f1$var$i18n.edit : $e7b359a64ad828f1$var$i18n.add) : '';
};

});
parcelRegister("eDV4X", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_CONTENT_STATUSES", () => $e24dc53dc88ae3e8$export$3211963609921415);
$parcel$export(module.exports, "ActionTypes", () => $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "INVALID_CHARACTERS", () => $e24dc53dc88ae3e8$export$cac90560d1a4fb86);
$parcel$export(module.exports, "ContentTypes", () => $e24dc53dc88ae3e8$export$b9e669a853ca2f38);
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});

});

parcelRegister("cUIkM", function(module, exports) {

$parcel$export(module.exports, "LabelsCountQuery", () => $865b819f05ce8472$export$83f92c0e89c7ef19);

var $d2LG0 = parcelRequire("d2LG0");
const $865b819f05ce8472$export$83f92c0e89c7ef19 = (0, $d2LG0.default)`query LabelsCountQuery($contentId:ID!$status:[String]){singleContent(id:$contentId status:$status){id labels(orderBy:{sortField:LABELLING_CREATIONDATE direction:ASCENDING}){count}}}`;

});


parcelRegister("4vaoM", function(module, exports) {

$parcel$export(module.exports, "EditLabelDialogLoader", () => $a85e440150ad6165$export$761f49b4caa7a581);

var $jmjWc = parcelRequire("jmjWc");

const $a85e440150ad6165$export$761f49b4caa7a581 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "JXn3W",
    name: "EditLabelDialogLoader",
    loader: async ()=>(await (parcelRequire("5ttkG"))).EditLabelDialogComponent
});

});
parcelRegister("5ttkG", function(module, exports) {

let $3fc66a0c08497b1b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $3fc66a0c08497b1b$var$load("1kb22"),
    $3fc66a0c08497b1b$var$load("1fnbu")
]).then(()=>parcelRequire('m0wkE'));

});



parcelRegister("dZ4NH", function(module, exports) {

$parcel$export(module.exports, "ResolvedInlineCommentsDialogLoader", () => $c85e5a0a8019d662$export$492577bc4a81367b);
$parcel$export(module.exports, "ResolvedInlineCommentsCounterLoader", () => $c85e5a0a8019d662$export$20020b6b9f67a9ec);

var $jmjWc = parcelRequire("jmjWc");

const $c85e5a0a8019d662$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aBZFP",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("r50MK"))).ResolvedInlineCommentsDialog
});

const $c85e5a0a8019d662$export$910771def0791455 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xHM7h",
    name: "ResolvedInlineCommentsQueryRendererLoader",
    loader: async ()=>(await (parcelRequire("do6Wx"))).ResolvedInlineCommentsQueryRenderer
});

const $c85e5a0a8019d662$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "a-qcu",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("5WHor"))).ResolvedInlineCommentsCounter
});

});
parcelRegister("r50MK", function(module, exports) {

let $051668f19439e408$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $051668f19439e408$var$load("hOsjc").then(()=>parcelRequire('92Mdh'));

});

parcelRegister("do6Wx", function(module, exports) {

let $0283eaf3b6d858d6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $0283eaf3b6d858d6$var$load("km34l").then(()=>parcelRequire('hytVp'));

});

parcelRegister("5WHor", function(module, exports) {

let $4544078af29d28e4$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $4544078af29d28e4$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});


parcelRegister("iff8m", function(module, exports) {

$parcel$export(module.exports, "AnalyticsPluginWrapper", () => $d4855df5f39765b9$export$9fe33c952d508e42);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $2UWuP = parcelRequire("2UWuP");

var $hFGQl = parcelRequire("hFGQl");
const $d4855df5f39765b9$var$getAnalyticsData = (webItemId)=>{
    const fromName = webItemId === (0, $hFGQl.ANALYTICS_ADDON_BYLINE_ID) ? 'fromByline' : 'fromActionMenu';
    const event = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            source: 'viewPageScreen',
            actionSubject: 'AnalyticsButton',
            attributes: {
                from: fromName,
                type: 'viewers'
            }
        }
    };
    return event;
};
class $d4855df5f39765b9$export$9fe33c952d508e42 extends (0, $gwFzn.PureComponent) {
    render() {
        const { webItemId: webItemId } = this.props;
        const analyticsData = $d4855df5f39765b9$var$getAnalyticsData(webItemId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2UWuP.WebItemAnalyticsWrapper), {
            analyticsData: analyticsData
        }, this.props.children);
    }
}
$d4855df5f39765b9$export$9fe33c952d508e42.propTypes = {
    webItemId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).node.isRequired
};

});
parcelRegister("2UWuP", function(module, exports) {

$parcel$export(module.exports, "WebItemAnalyticsWrapper", () => $1c62d6fee936c450$export$907c57431ebf932);

var $gwFzn = parcelRequire("gwFzn");

var $Asv1P = parcelRequire("Asv1P");
const $1c62d6fee936c450$var$noop = ()=>{};
function $1c62d6fee936c450$export$907c57431ebf932({ children: children, analyticsData: analyticsData, innerRef: innerRef, wrapChildren: wrapChildren = false }) {
    const handler = children?.props?.onClick || $1c62d6fee936c450$var$noop;
    const handleClick = (0, $Asv1P.useCallbackWithAnalytics)(handler, analyticsData);
    if (wrapChildren) return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        ref: innerRef,
        onMouseDown: handleClick
    }, children));
    return /*#__PURE__*/ (0, $gwFzn.cloneElement)(children, {
        onClick: handleClick,
        ref: innerRef
    });
}

});


parcelRegister("jcM8h", function(module, exports) {

$parcel$export(module.exports, "ContentOwnerPopupComponent", () => $a26c936fb563039b$export$62380b37452323f8);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $j1Ss3 = parcelRequire("j1Ss3");

var $eEA8O = parcelRequire("eEA8O");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $jPwBx = parcelRequire("jPwBx");

var $dAYOx = parcelRequire("dAYOx");

var $lGgRw = parcelRequire("lGgRw");

var $irVI7 = parcelRequire("irVI7");

var $a6t12 = parcelRequire("a6t12");

var $68BwE = parcelRequire("68BwE");

var $jFm04 = parcelRequire("jFm04");

var $3SLf9 = parcelRequire("3SLf9");
const $a26c936fb563039b$var$i18n = (0, $2nPZH.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $ecnYn.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ]
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $dBxQj.default)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $gwFzn.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eEA8O.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id history{createdBy{displayName ...on KnownUser{accountId}...on User{accountId}}ownedBy{displayName ...on KnownUser{accountId}...on User{accountId}}}}}`, {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPwBx))), {
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, itemLabel))
    });
};

});
parcelRegister("3SLf9", function(module, exports) {

$parcel$export(module.exports, "useIsAllowedToChangeOwner", () => $93ff62a422a2769d$export$fe5ee8722fdedf98);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $5k5SG = parcelRequire("5k5SG");
const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    return (0, $gwFzn.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isSpaceOrSiteAdmin || isCurrentUserOwner;
    }, [
        isSpaceOrSiteAdmin,
        ownedByAccountId,
        userId
    ]);
};

});


parcelRegister("l3C2L", function(module, exports) {

$parcel$export(module.exports, "ViewChangesDialogLoader", () => $ff94b9918380dc5d$export$cc6c027a319af205);

var $jmjWc = parcelRequire("jmjWc");

const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("axySR"))).ViewChangesDialog
});

});
parcelRegister("axySR", function(module, exports) {

let $7ac80bae6dfc6eef$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $7ac80bae6dfc6eef$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});


parcelRegister("93ydA", function(module, exports) {

$parcel$export(module.exports, "ExpandableSubMenuItem", () => $4370c71127b919ef$export$12fcc661fcb02eff);
/* ExpandableSubMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $c4sKh = parcelRequire("c4sKh");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $jPwBx = parcelRequire("jPwBx");

var $56M4r = parcelRequire("56M4r");
// this is to keep consistent with ContentTools PopupMenuGroup
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4370c71127b919ef$var$StyledDropdownItemGroup = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $ahaN7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1ul91wdt _p12f1c3h",
            __cmplp.className
        ])
    });
});
const $4370c71127b919ef$var$DropdownItemLabelContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $4370c71127b919ef$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $4370c71127b919ef$export$12fcc661fcb02eff = ({ label: label, items: items, isSubMenuOpen: isSubMenuOpen, onMouseEnter: onMouseEnter, onClick: onClick, onOpenChange: onOpenChange })=>{
    if (!items.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "left-start",
        onOpenChange: onOpenChange,
        isOpen: isSubMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
                ...triggerProps,
                ref: triggerRef,
                // @ts-ignore
                onMouseEnter: onMouseEnter,
                onClick: onClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPwBx))), {
                    color: "currentColor",
                    label: ""
                }),
                role: "menuitem"
            }, label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4370c71127b919ef$var$StyledDropdownItemGroup, null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: item.id,
            href: item.url,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($4370c71127b919ef$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, item.label), item.badgeLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $4370c71127b919ef$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c4sKh.default), null, item.badgeLabel)) : null)))));
};

});

parcelRegister("lI54U", function(module, exports) {

$parcel$export(module.exports, "PageAppsExpandableSubMenuItems", () => $eccbd7bc796a38d4$export$8b373c6942d1d4a2);
/* PageAppsExpandableSubMenuItems.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $c4sKh = parcelRequire("c4sKh");

var $52EPl = parcelRequire("52EPl");
var $dAYOx = parcelRequire("dAYOx");
var $ahaN7 = parcelRequire("ahaN7");

var $jPwBx = parcelRequire("jPwBx");

var $56M4r = parcelRequire("56M4r");
// this is to keep consistent with ContentTools PopupMenuGroup
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $eccbd7bc796a38d4$var$StyledDropdownItemGroup = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $ahaN7.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1ul91wdt _p12f1c3h",
            __cmplp.className
        ])
    });
});
const $eccbd7bc796a38d4$var$DropdownItemLabelContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $eccbd7bc796a38d4$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
const $eccbd7bc796a38d4$export$7a3b78bc1d3676d9 = (styleClass)=>{
    return !styleClass?.includes('aui-button') ? styleClass : '';
};
const $eccbd7bc796a38d4$export$8b373c6942d1d4a2 = ({ label: label, items: items, isSubMenuOpen: isSubMenuOpen, onMouseEnter: onMouseEnter, onClick: onClick, forgeMenuItems: forgeMenuItems, onOpenChange: onOpenChange })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $52EPl.default), {
        placement: "left-start",
        onOpenChange: onOpenChange,
        isOpen: isSubMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
                ...triggerProps,
                ref: triggerRef,
                // @ts-ignore
                onMouseEnter: onMouseEnter,
                onClick: onClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jPwBx))), {
                    color: "currentColor",
                    label: ""
                })
            }, label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($eccbd7bc796a38d4$var$StyledDropdownItemGroup, null, items.map((item, index)=>// className is needed here for Connect modals to show properly
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $eccbd7bc796a38d4$export$7a3b78bc1d3676d9(item?.styleClass),
            "data-testid": `item-wrapper-${index}`,
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dAYOx.default), {
            key: item.id,
            href: item.url,
            UNSAFE_shouldDisableRouterLink: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($eccbd7bc796a38d4$var$DropdownItemLabelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", null, item.label || item?.tooltip), item.badgeLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            xcss: $eccbd7bc796a38d4$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $c4sKh.default), null, item.badgeLabel)) : null)))), forgeMenuItems));
};

});

parcelRegister("6DX3n", function(module, exports) {

$parcel$export(module.exports, "i18n", () => $a4d3843be7f7fab1$export$a7357cdd1f0b0168);

var $2nPZH = parcelRequire("2nPZH");
const $a4d3843be7f7fab1$export$a7357cdd1f0b0168 = (0, $2nPZH.defineMessages)({
    viewChanges: {
        id: "editor-ellipsis-dropdown.open.ellipsis.view.changes",
        defaultMessage: "View changes"
    },
    resolvedComments: {
        id: "editor-ellipsis-dropdown.open.ellipsis.resolved.comments",
        defaultMessage: "Resolved comments"
    },
    templateImportDocs: {
        id: "editor-ellipsis-dropdown.ellipsis.open.ellipsis.templates.and.import",
        defaultMessage: "Templates & import doc"
    },
    more: {
        id: "editor-ellipsis-dropdown.open.ellipsis.more",
        defaultMessage: "More"
    }
});

});

parcelRegister("kvwCJ", function(module, exports) {

let $eee00248482c1f55$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $eee00248482c1f55$var$load("iEtMu").then(()=>parcelRequire('gha5G'));

});



parcelRegister("Qlykt", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SIZE_MEDIUM", () => $f866e8db934ec558$export$d7240ab6bd9deaf0);
$parcel$export(module.exports, "EMOJI_SIZE_LARGE", () => $f866e8db934ec558$export$7d383c70a74caba8);
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;

});

parcelRegister("g3p2i", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $fc6a2e7c662c45f6$export$8995abb8169b2cb8);
$parcel$export(module.exports, "SitePermissionTypeFilter", () => $fc6a2e7c662c45f6$export$3347a7c058a0368a);
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});

});

parcelRegister("hpRYU", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchPicker", () => $4cbf051190fe8573$export$ca514d5352bb0171);
/* UserAndGroupSearchPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $4jR19 = parcelRequire("4jR19");

var $kSKAi = parcelRequire("kSKAi");

var $7rus4 = parcelRequire("7rus4");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $kr1Wj = parcelRequire("kr1Wj");

var $7Sm4c = parcelRequire("7Sm4c");

var $jjoF2 = parcelRequire("jjoF2");

var $g3p2i = parcelRequire("g3p2i");
const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cbf051190fe8573$var$DefaultWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1f1u1ylp _4g2iv77o _pfyjv77o",
            __cmplp.className
        ])
    });
});
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, client: client, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, allowEmail: allowEmail, includeTeams: includeTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId })=>{
    const [error, setError] = (0, $gwFzn.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $j1Ss3.useQuery)((0, $d2LG0.default)`query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}`);
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError); // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            client: client,
            includeGroup: includeGroup,
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.search.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Sorry, we're having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.permission.error" // TODO: replace straight quotes with curly quotes (see go/curlyquotes)
        ,
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "We couldn't find any results because you don't have permission to search the user directory."
    }); // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $kr1Wj.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.groups" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        id: "user-and-group-search.placeholder.text.users" // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        ,
        defaultMessage: "Type a user name"
    }));
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        allowEmail: allowEmail,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        withUsers: withUsers,
        header: header,
        open: open,
        'aria-labelledby': `react-select-${fieldId}-placeholder`,
        'aria-describedby': userpickerDescribedbyId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kSKAi.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rus4.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context" // infer principal ID from UCT
        ,
        productKey: "confluence" // eslint-disable-next-line jsx-a11y/no-autofocus
        ,
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = (0, $j1Ss3.withApollo)($4cbf051190fe8573$export$fd4159eb872f73c6);

});
parcelRegister("jjoF2", function(module, exports) {

$parcel$export(module.exports, "userGroupSearchPromise", () => $9d3a4572140e810a$export$c139484855007019);

var $9fywD = parcelRequire("9fywD");

var $11dKl = parcelRequire("11dKl");

var $9eE57 = parcelRequire("9eE57");

var $g3p2i = parcelRequire("g3p2i");

var $6RGMW = parcelRequire("6RGMW");
const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, client: client, includeGroup: includeGroup, customInclusion: customInclusion, setError: setError, sitePermissionTypeFilter: sitePermissionTypeFilter, filterResults: filterResults, withUsers: withUsers })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return client.query({
        query: (0, $6RGMW.UserAndGroupSearchQuery),
        variables: {
            withGroups: includeGroup,
            searchTerm: searchTerm,
            sitePermissionTypeFilter: sitePermissionTypeFilter,
            withUsers: withUsers
        }
    }).then(({ data: data })=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch;
        const userList = users.map((item)=>({
                id: `user-${item.accountId}`,
                name: item.displayName,
                extra: item,
                type: 'user',
                avatarUrl: item.profilePicture ? item.profilePicture.path : '',
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item.id}`,
                name: item.name,
                type: 'group',
                extra: item,
                lozenge: item.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().startsWith(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};

});
parcelRegister("11dKl", function(module, exports) {

$parcel$export(module.exports, "ExternalGroupLozengeProps", () => $f9006b515271a00f$export$fef38ba78dbe85a6);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $aIk0I = parcelRequire("aIk0I");

var $3gadb = parcelRequire("3gadb");
const $f9006b515271a00f$var$i18n = (0, $2nPZH.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aIk0I.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};

});

parcelRegister("6RGMW", function(module, exports) {

$parcel$export(module.exports, "UserAndGroupSearchQuery", () => $88fbd0e78227b736$export$9eed0d08b5194ae7);

var $d2LG0 = parcelRequire("d2LG0");
const $88fbd0e78227b736$export$9eed0d08b5194ae7 = (0, $d2LG0.default)`query UserAndGroupSearchQuery($searchTerm:String!$maxResults:Int=50$withGroups:Boolean=true$withUsers:Boolean=true$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm maxResults:$maxResults sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){type displayName permissionType profilePicture{path}...on User{accountId}...on KnownUser{accountId}}groups@include(if:$withGroups){id name permissionType}}}`;

});



parcelRegister("bVAxT", function(module, exports) {

$parcel$export(module.exports, "RestrictionsDialogStateContainer", () => $20c3e8ab10e63e24$export$f91385b453474810);
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $ipPpS = parcelRequire("ipPpS");
class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $ipPpS.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}

});

parcelRegister("dO5HR", function(module, exports) {

$parcel$export(module.exports, "InspectPermissionsDialog", () => $e05d6d01b1afcacd$export$44ec82a0a8c60a0e);
$parcel$export(module.exports, "InspectPermissionsEntryPoint", () => $e05d6d01b1afcacd$export$49d28052e29cecf7);

var $jmjWc = parcelRequire("jmjWc");


const $e05d6d01b1afcacd$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "X2r4g",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("fteO4"))).InspectPermissionsDialog
});

const $e05d6d01b1afcacd$export$49d28052e29cecf7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "_PpYB",
    name: "InspectPermissionsEntryPoint",
    loader: async ()=>(await (parcelRequire("fnRSC"))).InspectPermissionsEntryPoint
});

});
parcelRegister("fteO4", function(module, exports) {

let $b4350cbfddd87ee1$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b4350cbfddd87ee1$var$load("14XOE"),
    $b4350cbfddd87ee1$var$load("77pyi"),
    $b4350cbfddd87ee1$var$load("7rEYM"),
    $b4350cbfddd87ee1$var$load("f96v0"),
    $b4350cbfddd87ee1$var$load("ev7SX"),
    $b4350cbfddd87ee1$var$load("gQSWJ"),
    $b4350cbfddd87ee1$var$load("5tHTv"),
    $b4350cbfddd87ee1$var$load("c6MKV"),
    $b4350cbfddd87ee1$var$load("dTsOE"),
    $b4350cbfddd87ee1$var$load("4aLlP"),
    $b4350cbfddd87ee1$var$load("aZinD"),
    $b4350cbfddd87ee1$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("fnRSC", function(module, exports) {

let $b332cc68e14cb990$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b332cc68e14cb990$var$load("7rEYM"),
    $b332cc68e14cb990$var$load("69XGw")
]).then(()=>parcelRequire('lJ0CS'));

});


parcelRegister("3P1RK", function(module, exports) {

$parcel$export(module.exports, "SpacePermissionsTabKey", () => $4a56ff9e2636e665$export$ad59ff7dc414850a);
$parcel$export(module.exports, "SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP", () => $4a56ff9e2636e665$export$d4f1d7ffc41e2d29);

var $fHoxN = parcelRequire("fHoxN");
var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};

});
parcelRegister("fHoxN", function(module, exports) {

$parcel$export(module.exports, "PermissionDisplayType", () => $8a20bb30841ead37$export$f1a726cdbae0d72a);
$parcel$export(module.exports, "SpacePermissionType", () => $8a20bb30841ead37$export$a99f5dae9c149910);
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});

});



//# sourceMappingURL=LivePagesEllipsisDropdown.a9f3df8b.js.map
